// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as HybridRouteRouteImport } from './routes/_hybrid/route'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as AuthAdminRouteRouteImport } from './routes/_auth/_admin/route'
import { Route as AuthAthleteRouteRouteImport } from './routes/_auth/_athlete/route'
import { Route as AuthCoachRouteRouteImport } from './routes/_auth/_coach/route'
import { Route as AuthChatRouteRouteImport } from './routes/_auth/chat/route'
import { Route as AuthSettingsRouteRouteImport } from './routes/_auth/settings/route'
import { Route as HybridConnectRouteImport } from './routes/_hybrid/connect'
import { Route as PublicContactRouteImport } from './routes/_public/contact'
import { Route as PublicDeleteAccountRouteImport } from './routes/_public/delete-account'
import { Route as PublicPrivacyRouteImport } from './routes/_public/privacy'
import { Route as PublicResetPasswordRouteRouteImport } from './routes/_public/reset-password/route'
import { Route as PublicSignInRouteImport } from './routes/_public/sign-in'
import { Route as PublicSignUpRouteImport } from './routes/_public/sign-up'
import { Route as CSlugRouteImport } from './routes/c/$slug'
import { Route as OrganizationInvitationsInvitationIdRouteImport } from './routes/organization-invitations.$invitationId'
import { Route as VerifyEmailVerificationIdRouteImport } from './routes/verify-email/$verificationId'
import { Route as AuthAthleteCalendarRouteRouteImport } from './routes/_auth/_athlete/calendar/route'
import { Route as AuthAthletePaymentsRouteImport } from './routes/_auth/_athlete/payments'
import { Route as AuthAthleteProgramsRouteRouteImport } from './routes/_auth/_athlete/programs/route'
import { Route as AuthAthleteQuestionnaireSubmissionsRouteRouteImport } from './routes/_auth/_athlete/questionnaire-submissions/route'
import { Route as AuthCoachAiRouteRouteImport } from './routes/_auth/_coach/ai/route'
import { Route as AuthCoachAthletesRouteRouteImport } from './routes/_auth/_coach/athletes/route'
import { Route as AuthCoachAutomationsRouteRouteImport } from './routes/_auth/_coach/automations/route'
import { Route as AuthCoachContentHubRouteRouteImport } from './routes/_auth/_coach/content-hub/route'
import { Route as AuthCoachCreateOrgRouteImport } from './routes/_auth/_coach/create-org'
import { Route as AuthCoachProductsRouteRouteImport } from './routes/_auth/_coach/products/route'
import { Route as AuthCoachProfileRouteRouteImport } from './routes/_auth/_coach/profile/route'
import { Route as AuthCoachQuestionnairesRouteRouteImport } from './routes/_auth/_coach/questionnaires/route'
import { Route as AuthChatIndexRouteImport } from './routes/_auth/chat/index'
import { Route as AuthChatChatIdRouteImport } from './routes/_auth/chat/$chatId'
import { Route as AuthInvitationsIndexRouteImport } from './routes/_auth/invitations/index'
import { Route as AuthSettingsIndexRouteImport } from './routes/_auth/settings/index'
import { Route as AuthSettingsBillingRouteImport } from './routes/_auth/settings/billing'
import { Route as AuthSettingsIntegrationsRouteRouteImport } from './routes/_auth/settings/integrations/route'
import { Route as AuthSettingsMcpRouteImport } from './routes/_auth/settings/mcp'
import { Route as AuthSettingsPreferencesRouteImport } from './routes/_auth/settings/preferences'
import { Route as HybridWorkflowWorkflowIdRouteRouteImport } from './routes/_hybrid/workflow.$workflowId/route'
import { Route as PublicInvitationsInvitationIdRouteRouteImport } from './routes/_public/invitations.$invitationId/route'
import { Route as PublicResetPasswordIndexRouteImport } from './routes/_public/reset-password/index'
import { Route as PublicResetPasswordResetIdRouteImport } from './routes/_public/reset-password/$resetId'
import { Route as PublicSharedSharedIdRouteImport } from './routes/_public/shared/$sharedId'
import { Route as AuthAdminAdminBillingRouteRouteImport } from './routes/_auth/_admin/admin/billing/route'
import { Route as AuthAdminAdminFeatureFlagsRouteRouteImport } from './routes/_auth/_admin/admin/feature-flags/route'
import { Route as AuthAdminAdminInvitationCodesRouteImport } from './routes/_auth/_admin/admin/invitation-codes'
import { Route as AuthAdminAdminMetricsRouteRouteImport } from './routes/_auth/_admin/admin/metrics/route'
import { Route as AuthAdminAdminProductsRouteImport } from './routes/_auth/_admin/admin/products'
import { Route as AuthAdminAdminStravaWebhookRouteImport } from './routes/_auth/_admin/admin/strava-webhook'
import { Route as AuthAthleteCalendarIndexRouteImport } from './routes/_auth/_athlete/calendar/index'
import { Route as AuthAthleteProgramsIndexRouteImport } from './routes/_auth/_athlete/programs/index'
import { Route as AuthAthleteProgramsProgramIdRouteRouteImport } from './routes/_auth/_athlete/programs/$programId/route'
import { Route as AuthAthleteQuestionnaireSubmissionsIndexRouteImport } from './routes/_auth/_athlete/questionnaire-submissions/index'
import { Route as AuthAthleteQuestionnaireSubmissionsSubmissionIdRouteRouteImport } from './routes/_auth/_athlete/questionnaire-submissions/$submissionId/route'
import { Route as AuthCoachAiIndexRouteImport } from './routes/_auth/_coach/ai/index'
import { Route as AuthCoachAiChatIdRouteImport } from './routes/_auth/_coach/ai/$chatId'
import { Route as AuthCoachAthletesIndexRouteImport } from './routes/_auth/_coach/athletes/index'
import { Route as AuthCoachAthletesAthleteIdRouteRouteImport } from './routes/_auth/_coach/athletes/$athleteId/route'
import { Route as AuthCoachAutomationsIndexRouteImport } from './routes/_auth/_coach/automations/index'
import { Route as AuthCoachAutomationsAutomationIdRouteRouteImport } from './routes/_auth/_coach/automations/$automationId/route'
import { Route as AuthCoachAutomationsNewRouteImport } from './routes/_auth/_coach/automations/new'
import { Route as AuthCoachBundlesIndexRouteImport } from './routes/_auth/_coach/bundles/index'
import { Route as AuthCoachContentHubIndexRouteImport } from './routes/_auth/_coach/content-hub/index'
import { Route as AuthCoachContentHubContentHubIdRouteRouteImport } from './routes/_auth/_coach/content-hub/$contentHubId/route'
import { Route as AuthCoachLabelsIndexRouteImport } from './routes/_auth/_coach/labels/index'
import { Route as AuthCoachLibraryIndexRouteImport } from './routes/_auth/_coach/library/index'
import { Route as AuthCoachLibraryExercisesRouteRouteImport } from './routes/_auth/_coach/library/exercises/route'
import { Route as AuthCoachLibraryProgramsRouteRouteImport } from './routes/_auth/_coach/library/programs/route'
import { Route as AuthCoachLibrarySectionsRouteRouteImport } from './routes/_auth/_coach/library/sections/route'
import { Route as AuthCoachLibraryWorkoutsRouteRouteImport } from './routes/_auth/_coach/library/workouts/route'
import { Route as AuthCoachOrgsSlugRouteRouteImport } from './routes/_auth/_coach/orgs/$slug/route'
import { Route as AuthCoachProductsProductIdRouteRouteImport } from './routes/_auth/_coach/products/$productId/route'
import { Route as AuthCoachProductsTabsRouteImport } from './routes/_auth/_coach/products/_tabs'
import { Route as AuthCoachProductsNewRouteImport } from './routes/_auth/_coach/products/new'
import { Route as AuthCoachProfileSectionRouteImport } from './routes/_auth/_coach/profile/$section'
import { Route as AuthCoachProfileLeadsRouteImport } from './routes/_auth/_coach/profile/leads'
import { Route as AuthCoachQuestionnairesIndexRouteImport } from './routes/_auth/_coach/questionnaires/index'
import { Route as AuthCoachQuestionnairesQuestionnaireIdRouteRouteImport } from './routes/_auth/_coach/questionnaires/$questionnaireId/route'
import { Route as AuthCoachWorkflowsIndexRouteImport } from './routes/_auth/_coach/workflows/index'
import { Route as AuthCoachWorkflowsWorkflowIdRouteRouteImport } from './routes/_auth/_coach/workflows/$workflowId/route'
import { Route as AuthSettingsIntegrationsIndexRouteImport } from './routes/_auth/settings/integrations/index'
import { Route as AuthSettingsIntegrationsAppleHealthRouteRouteImport } from './routes/_auth/settings/integrations/apple-health/route'
import { Route as AuthSettingsIntegrationsStravaRouteRouteImport } from './routes/_auth/settings/integrations/strava/route'
import { Route as HybridWorkflowWorkflowIdJoinRouteImport } from './routes/_hybrid/workflow.$workflowId/join'
import { Route as PublicInvitationsInvitationIdIndexRouteImport } from './routes/_public/invitations.$invitationId/index'
import { Route as CSlugPProductSlugRouteImport } from './routes/c/$slug_/p/$productSlug'
import { Route as AuthAdminAdminBillingIndexRouteImport } from './routes/_auth/_admin/admin/billing/index'
import { Route as AuthAdminAdminBillingActionsRouteImport } from './routes/_auth/_admin/admin/billing/actions'
import { Route as AuthAdminAdminBillingFeaturesRouteImport } from './routes/_auth/_admin/admin/billing/features'
import { Route as AuthAdminAdminFeatureFlagsIndexRouteImport } from './routes/_auth/_admin/admin/feature-flags/index'
import { Route as AuthAdminAdminFeatureFlagsAccessRouteImport } from './routes/_auth/_admin/admin/feature-flags/access'
import { Route as AuthAdminAdminMetricsIndexRouteImport } from './routes/_auth/_admin/admin/metrics/index'
import { Route as AuthAdminAdminMetricsIntegrationConfigsRouteImport } from './routes/_auth/_admin/admin/metrics/integration-configs'
import { Route as AuthAthleteQuestionnaireSubmissionsSubmissionIdIndexRouteImport } from './routes/_auth/_athlete/questionnaire-submissions/$submissionId/index'
import { Route as AuthCoachAthletesAthleteIdTabsRouteImport } from './routes/_auth/_coach/athletes/$athleteId/_tabs'
import { Route as AuthCoachAthletesAthleteIdProgramsRouteRouteImport } from './routes/_auth/_coach/athletes/$athleteId/programs/route'
import { Route as AuthCoachAutomationsAutomationIdIndexRouteImport } from './routes/_auth/_coach/automations/$automationId/index'
import { Route as AuthCoachAutomationsAutomationIdRunsRouteImport } from './routes/_auth/_coach/automations/$automationId/runs'
import { Route as AuthCoachContentHubContentHubIdIndexRouteImport } from './routes/_auth/_coach/content-hub/$contentHubId/index'
import { Route as AuthCoachContentHubContentHubIdSplatRouteImport } from './routes/_auth/_coach/content-hub/$contentHubId/$'
import { Route as AuthCoachContentHubContentHubIdAssignedAthletesRouteImport } from './routes/_auth/_coach/content-hub/$contentHubId/assigned-athletes'
import { Route as AuthCoachLibraryExercisesIndexRouteImport } from './routes/_auth/_coach/library/exercises/index'
import { Route as AuthCoachLibraryExercisesExerciseIdRouteImport } from './routes/_auth/_coach/library/exercises/$exerciseId'
import { Route as AuthCoachLibraryProgramsIndexRouteImport } from './routes/_auth/_coach/library/programs/index'
import { Route as AuthCoachLibraryProgramsProgramIdRouteRouteImport } from './routes/_auth/_coach/library/programs/$programId/route'
import { Route as AuthCoachLibraryResourcesIndexRouteImport } from './routes/_auth/_coach/library/resources/index'
import { Route as AuthCoachLibrarySectionsIndexRouteImport } from './routes/_auth/_coach/library/sections/index'
import { Route as AuthCoachLibraryTasksIndexRouteImport } from './routes/_auth/_coach/library/tasks/index'
import { Route as AuthCoachLibraryWorkoutsIndexRouteImport } from './routes/_auth/_coach/library/workouts/index'
import { Route as AuthCoachLibraryWorkoutsWorkoutIdRouteImport } from './routes/_auth/_coach/library/workouts/$workoutId'
import { Route as AuthCoachOrgsSlugIndexRouteImport } from './routes/_auth/_coach/orgs/$slug/index'
import { Route as AuthCoachOrgsSlugAthletesRouteRouteImport } from './routes/_auth/_coach/orgs/$slug/athletes/route'
import { Route as AuthCoachOrgsSlugExercisesRouteRouteImport } from './routes/_auth/_coach/orgs/$slug/exercises/route'
import { Route as AuthCoachOrgsSlugProgramsRouteRouteImport } from './routes/_auth/_coach/orgs/$slug/programs/route'
import { Route as AuthCoachOrgsSlugSettingsRouteRouteImport } from './routes/_auth/_coach/orgs/$slug/settings/route'
import { Route as AuthCoachOrgsSlugWorkoutsRouteRouteImport } from './routes/_auth/_coach/orgs/$slug/workouts/route'
import { Route as AuthCoachProductsProductIdTabsRouteImport } from './routes/_auth/_coach/products/$productId/_tabs'
import { Route as AuthCoachProductsProductIdAutomationsRouteRouteImport } from './routes/_auth/_coach/products/$productId/automations/route'
import { Route as AuthCoachProductsTabsIndexRouteImport } from './routes/_auth/_coach/products/_tabs/index'
import { Route as AuthCoachProductsTabsInvoicingRouteImport } from './routes/_auth/_coach/products/_tabs/invoicing'
import { Route as AuthCoachProductsTabsPaymentSetupRouteImport } from './routes/_auth/_coach/products/_tabs/payment-setup'
import { Route as AuthCoachProductsTabsPromoCodesRouteImport } from './routes/_auth/_coach/products/_tabs/promo-codes'
import { Route as AuthCoachProductsTabsSalesRouteImport } from './routes/_auth/_coach/products/_tabs/sales'
import { Route as AuthCoachProductsTabsSubscriptionsRouteImport } from './routes/_auth/_coach/products/_tabs/subscriptions'
import { Route as AuthCoachQuestionnairesQuestionnaireIdIndexRouteImport } from './routes/_auth/_coach/questionnaires/$questionnaireId/index'
import { Route as AuthCoachQuestionnairesQuestionnaireIdSubmissionsRouteRouteImport } from './routes/_auth/_coach/questionnaires/$questionnaireId/submissions/route'
import { Route as AuthCoachWorkflowsWorkflowIdIndexRouteImport } from './routes/_auth/_coach/workflows/$workflowId/index'
import { Route as AuthCoachWorkflowsWorkflowIdAthletesRouteImport } from './routes/_auth/_coach/workflows/$workflowId/athletes'
import { Route as AuthCoachWorkflowsWorkflowIdScheduleRouteImport } from './routes/_auth/_coach/workflows/$workflowId/schedule'
import { Route as AuthCoachWorkflowsWorkflowIdSettingsRouteImport } from './routes/_auth/_coach/workflows/$workflowId/settings'
import { Route as AuthSettingsIntegrationsAppleHealthIndexRouteImport } from './routes/_auth/settings/integrations/apple-health/index'
import { Route as AuthSettingsIntegrationsStravaIndexRouteImport } from './routes/_auth/settings/integrations/strava/index'
import { Route as AuthSettingsIntegrationsStravaActivitiesRouteImport } from './routes/_auth/settings/integrations/strava/activities'
import { Route as CSlugPProductSlugSuccessRouteImport } from './routes/c/$slug_/p/$productSlug_/success'
import { Route as AuthCoachAthletesAthleteIdTabsPaymentsRouteImport } from './routes/_auth/_coach/athletes/$athleteId/_tabs/payments'
import { Route as AuthCoachAthletesAthleteIdTabsProfileRouteImport } from './routes/_auth/_coach/athletes/$athleteId/_tabs/profile'
import { Route as AuthCoachAthletesAthleteIdTabsStatisticsRouteImport } from './routes/_auth/_coach/athletes/$athleteId/_tabs/statistics'
import { Route as AuthCoachAthletesAthleteIdProgramsProgramIdRouteRouteImport } from './routes/_auth/_coach/athletes/$athleteId/programs/$programId/route'
import { Route as AuthCoachAthletesAthleteIdProgramsTabsRouteImport } from './routes/_auth/_coach/athletes/$athleteId/programs/_tabs'
import { Route as AuthCoachLibraryProgramsProgramIdIndexRouteImport } from './routes/_auth/_coach/library/programs/$programId/index'
import { Route as AuthCoachLibraryProgramsProgramIdSharedRouteRouteImport } from './routes/_auth/_coach/library/programs/$programId/shared/route'
import { Route as AuthCoachOrgsSlugAthletesIndexRouteImport } from './routes/_auth/_coach/orgs/$slug/athletes/index'
import { Route as AuthCoachOrgsSlugAthletesAthleteIdRouteRouteImport } from './routes/_auth/_coach/orgs/$slug/athletes/$athleteId/route'
import { Route as AuthCoachOrgsSlugExercisesIndexRouteImport } from './routes/_auth/_coach/orgs/$slug/exercises/index'
import { Route as AuthCoachOrgsSlugExercisesExerciseIdRouteImport } from './routes/_auth/_coach/orgs/$slug/exercises/$exerciseId'
import { Route as AuthCoachOrgsSlugLabelsIndexRouteImport } from './routes/_auth/_coach/orgs/$slug/labels/index'
import { Route as AuthCoachOrgsSlugProgramsIndexRouteImport } from './routes/_auth/_coach/orgs/$slug/programs/index'
import { Route as AuthCoachOrgsSlugSettingsIndexRouteImport } from './routes/_auth/_coach/orgs/$slug/settings/index'
import { Route as AuthCoachOrgsSlugSettingsBillingRouteImport } from './routes/_auth/_coach/orgs/$slug/settings/billing'
import { Route as AuthCoachOrgsSlugSettingsIntegrationsRouteRouteImport } from './routes/_auth/_coach/orgs/$slug/settings/integrations/route'
import { Route as AuthCoachOrgsSlugSettingsMcpRouteImport } from './routes/_auth/_coach/orgs/$slug/settings/mcp'
import { Route as AuthCoachOrgsSlugSettingsMembersRouteImport } from './routes/_auth/_coach/orgs/$slug/settings/members'
import { Route as AuthCoachOrgsSlugSettingsPreferencesRouteImport } from './routes/_auth/_coach/orgs/$slug/settings/preferences'
import { Route as AuthCoachOrgsSlugSettingsProfileRouteImport } from './routes/_auth/_coach/orgs/$slug/settings/profile'
import { Route as AuthCoachOrgsSlugWorkoutsIndexRouteImport } from './routes/_auth/_coach/orgs/$slug/workouts/index'
import { Route as AuthCoachProductsProductIdTabsIndexRouteImport } from './routes/_auth/_coach/products/$productId/_tabs/index'
import { Route as AuthCoachProductsProductIdAutomationsAutomationIdRouteRouteImport } from './routes/_auth/_coach/products/$productId/automations/$automationId/route'
import { Route as AuthCoachProductsProductIdAutomationsTabsRouteImport } from './routes/_auth/_coach/products/$productId/automations/_tabs'
import { Route as AuthCoachProductsProductIdAutomationsNewRouteImport } from './routes/_auth/_coach/products/$productId/automations/new'
import { Route as AuthCoachQuestionnairesQuestionnaireIdSubmissionsIndexRouteImport } from './routes/_auth/_coach/questionnaires/$questionnaireId/submissions/index'
import { Route as AuthCoachQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRouteImport } from './routes/_auth/_coach/questionnaires/$questionnaireId/submissions/$submissionId/route'
import { Route as AuthCoachAthletesAthleteIdTabsCalendarIndexRouteImport } from './routes/_auth/_coach/athletes/$athleteId/_tabs/calendar/index'
import { Route as AuthCoachAthletesAthleteIdTabsCalendarCalendarItemIdRouteImport } from './routes/_auth/_coach/athletes/$athleteId/_tabs/calendar/$calendarItemId'
import { Route as AuthCoachAthletesAthleteIdTabsMetricsIndexRouteImport } from './routes/_auth/_coach/athletes/$athleteId/_tabs/metrics/index'
import { Route as AuthCoachAthletesAthleteIdTabsQuestionnairesIndexRouteImport } from './routes/_auth/_coach/athletes/$athleteId/_tabs/questionnaires/index'
import { Route as AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRouteImport } from './routes/_auth/_coach/athletes/$athleteId/_tabs/questionnaires/$questionnaireId/route'
import { Route as AuthCoachAthletesAthleteIdProgramsProgramIdIndexRouteImport } from './routes/_auth/_coach/athletes/$athleteId/programs/$programId/index'
import { Route as AuthCoachAthletesAthleteIdProgramsTabsIndexRouteImport } from './routes/_auth/_coach/athletes/$athleteId/programs/_tabs/index'
import { Route as AuthCoachLibraryProgramsProgramIdSharedIndexRouteImport } from './routes/_auth/_coach/library/programs/$programId/shared/index'
import { Route as AuthCoachLibraryProgramsProgramIdSharedSharedProgramIdRouteRouteImport } from './routes/_auth/_coach/library/programs/$programId/shared/$sharedProgramId/route'
import { Route as AuthCoachOrgsSlugAthletesAthleteIdIndexRouteImport } from './routes/_auth/_coach/orgs/$slug/athletes/$athleteId/index'
import { Route as AuthCoachOrgsSlugAthletesAthleteIdTabsRouteImport } from './routes/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs'
import { Route as AuthCoachOrgsSlugSettingsIntegrationsIndexRouteImport } from './routes/_auth/_coach/orgs/$slug/settings/integrations/index'
import { Route as AuthCoachOrgsSlugSettingsIntegrationsAppleHealthRouteRouteImport } from './routes/_auth/_coach/orgs/$slug/settings/integrations/apple-health/route'
import { Route as AuthCoachOrgsSlugSettingsIntegrationsStravaRouteRouteImport } from './routes/_auth/_coach/orgs/$slug/settings/integrations/strava/route'
import { Route as AuthCoachProductsProductIdAutomationsAutomationIdIndexRouteImport } from './routes/_auth/_coach/products/$productId/automations/$automationId/index'
import { Route as AuthCoachProductsProductIdAutomationsAutomationIdRunsRouteImport } from './routes/_auth/_coach/products/$productId/automations/$automationId/runs'
import { Route as AuthCoachProductsProductIdAutomationsTabsIndexRouteImport } from './routes/_auth/_coach/products/$productId/automations/_tabs/index'
import { Route as AuthCoachQuestionnairesQuestionnaireIdSubmissionsSubmissionIdIndexRouteImport } from './routes/_auth/_coach/questionnaires/$questionnaireId/submissions/$submissionId/index'
import { Route as AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdIndexRouteImport } from './routes/_auth/_coach/athletes/$athleteId/_tabs/questionnaires/$questionnaireId/index'
import { Route as AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRouteImport } from './routes/_auth/_coach/athletes/$athleteId/_tabs/questionnaires/$questionnaireId/submissions/route'
import { Route as AuthCoachLibraryProgramsProgramIdSharedSharedProgramIdIndexRouteImport } from './routes/_auth/_coach/library/programs/$programId/shared/$sharedProgramId/index'
import { Route as AuthCoachOrgsSlugAthletesAthleteIdTabsProfileRouteImport } from './routes/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs/profile'
import { Route as AuthCoachOrgsSlugAthletesAthleteIdTabsStatisticsRouteImport } from './routes/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs/statistics'
import { Route as AuthCoachOrgsSlugSettingsIntegrationsAppleHealthIndexRouteImport } from './routes/_auth/_coach/orgs/$slug/settings/integrations/apple-health/index'
import { Route as AuthCoachOrgsSlugSettingsIntegrationsStravaIndexRouteImport } from './routes/_auth/_coach/orgs/$slug/settings/integrations/strava/index'
import { Route as AuthCoachOrgsSlugSettingsIntegrationsStravaActivitiesRouteImport } from './routes/_auth/_coach/orgs/$slug/settings/integrations/strava/activities'
import { Route as AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsIndexRouteImport } from './routes/_auth/_coach/athletes/$athleteId/_tabs/questionnaires/$questionnaireId/submissions/index'
import { Route as AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRouteImport } from './routes/_auth/_coach/athletes/$athleteId/_tabs/questionnaires/$questionnaireId/submissions/$submissionId/route'
import { Route as AuthCoachOrgsSlugAthletesAthleteIdTabsMetricsIndexRouteImport } from './routes/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs/metrics/index'
import { Route as AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesIndexRouteImport } from './routes/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs/questionnaires/index'
import { Route as AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRouteImport } from './routes/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs/questionnaires/$questionnaireId/route'
import { Route as AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdIndexRouteImport } from './routes/_auth/_coach/athletes/$athleteId/_tabs/questionnaires/$questionnaireId/submissions/$submissionId/index'
import { Route as AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdIndexRouteImport } from './routes/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs/questionnaires/$questionnaireId/index'
import { Route as AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRouteImport } from './routes/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs/questionnaires/$questionnaireId/submissions/route'
import { Route as AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsIndexRouteImport } from './routes/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs/questionnaires/$questionnaireId/submissions/index'
import { Route as AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRouteImport } from './routes/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs/questionnaires/$questionnaireId/submissions/$submissionId/route'
import { Route as AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdIndexRouteImport } from './routes/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs/questionnaires/$questionnaireId/submissions/$submissionId/index'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthRouteRoute = AuthRouteRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const HybridRouteRoute = HybridRouteRouteImport.update({
            id: '/_hybrid',getParentRoute: () => rootRouteImport
          })
const PublicRouteRoute = PublicRouteRouteImport.update({
            id: '/_public',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const AuthAdminRouteRoute = AuthAdminRouteRouteImport.update({
            id: '/_admin',getParentRoute: () => AuthRouteRoute
          })
const AuthAthleteRouteRoute = AuthAthleteRouteRouteImport.update({
            id: '/_athlete',getParentRoute: () => AuthRouteRoute
          })
const AuthCoachRouteRoute = AuthCoachRouteRouteImport.update({
            id: '/_coach',getParentRoute: () => AuthRouteRoute
          })
const AuthChatRouteRoute = AuthChatRouteRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => AuthRouteRoute
          })
const AuthSettingsRouteRoute = AuthSettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthRouteRoute
          })
const HybridConnectRoute = HybridConnectRouteImport.update({
            id: '/connect',path: '/connect',getParentRoute: () => HybridRouteRoute
          })
const PublicContactRoute = PublicContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => PublicRouteRoute
          })
const PublicDeleteAccountRoute = PublicDeleteAccountRouteImport.update({
            id: '/delete-account',path: '/delete-account',getParentRoute: () => PublicRouteRoute
          })
const PublicPrivacyRoute = PublicPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => PublicRouteRoute
          })
const PublicResetPasswordRouteRoute = PublicResetPasswordRouteRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => PublicRouteRoute
          })
const PublicSignInRoute = PublicSignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => PublicRouteRoute
          })
const PublicSignUpRoute = PublicSignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => PublicRouteRoute
          })
const CSlugRoute = CSlugRouteImport.update({
            id: '/c/$slug',path: '/c/$slug',getParentRoute: () => rootRouteImport
          })
const OrganizationInvitationsInvitationIdRoute = OrganizationInvitationsInvitationIdRouteImport.update({
            id: '/organization-invitations/$invitationId',path: '/organization-invitations/$invitationId',getParentRoute: () => rootRouteImport
          })
const VerifyEmailVerificationIdRoute = VerifyEmailVerificationIdRouteImport.update({
            id: '/verify-email/$verificationId',path: '/verify-email/$verificationId',getParentRoute: () => rootRouteImport
          })
const AuthAthleteCalendarRouteRoute = AuthAthleteCalendarRouteRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => AuthAthleteRouteRoute
          })
const AuthAthletePaymentsRoute = AuthAthletePaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => AuthAthleteRouteRoute
          })
const AuthAthleteProgramsRouteRoute = AuthAthleteProgramsRouteRouteImport.update({
            id: '/programs',path: '/programs',getParentRoute: () => AuthAthleteRouteRoute
          })
const AuthAthleteQuestionnaireSubmissionsRouteRoute = AuthAthleteQuestionnaireSubmissionsRouteRouteImport.update({
            id: '/questionnaire-submissions',path: '/questionnaire-submissions',getParentRoute: () => AuthAthleteRouteRoute
          })
const AuthCoachAiRouteRoute = AuthCoachAiRouteRouteImport.update({
            id: '/ai',path: '/ai',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthCoachAthletesRouteRoute = AuthCoachAthletesRouteRouteImport.update({
            id: '/athletes',path: '/athletes',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthCoachAutomationsRouteRoute = AuthCoachAutomationsRouteRouteImport.update({
            id: '/automations',path: '/automations',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthCoachContentHubRouteRoute = AuthCoachContentHubRouteRouteImport.update({
            id: '/content-hub',path: '/content-hub',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthCoachCreateOrgRoute = AuthCoachCreateOrgRouteImport.update({
            id: '/create-org',path: '/create-org',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthCoachProductsRouteRoute = AuthCoachProductsRouteRouteImport.update({
            id: '/products',path: '/products',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthCoachProfileRouteRoute = AuthCoachProfileRouteRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthCoachQuestionnairesRouteRoute = AuthCoachQuestionnairesRouteRouteImport.update({
            id: '/questionnaires',path: '/questionnaires',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthChatIndexRoute = AuthChatIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthChatRouteRoute
          })
const AuthChatChatIdRoute = AuthChatChatIdRouteImport.update({
            id: '/$chatId',path: '/$chatId',getParentRoute: () => AuthChatRouteRoute
          })
const AuthInvitationsIndexRoute = AuthInvitationsIndexRouteImport.update({
            id: '/invitations/',path: '/invitations/',getParentRoute: () => AuthRouteRoute
          })
const AuthSettingsIndexRoute = AuthSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthSettingsRouteRoute
          })
const AuthSettingsBillingRoute = AuthSettingsBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AuthSettingsRouteRoute
          })
const AuthSettingsIntegrationsRouteRoute = AuthSettingsIntegrationsRouteRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => AuthSettingsRouteRoute
          })
const AuthSettingsMcpRoute = AuthSettingsMcpRouteImport.update({
            id: '/mcp',path: '/mcp',getParentRoute: () => AuthSettingsRouteRoute
          })
const AuthSettingsPreferencesRoute = AuthSettingsPreferencesRouteImport.update({
            id: '/preferences',path: '/preferences',getParentRoute: () => AuthSettingsRouteRoute
          })
const HybridWorkflowWorkflowIdRouteRoute = HybridWorkflowWorkflowIdRouteRouteImport.update({
            id: '/workflow/$workflowId',path: '/workflow/$workflowId',getParentRoute: () => HybridRouteRoute
          })
const PublicInvitationsInvitationIdRouteRoute = PublicInvitationsInvitationIdRouteRouteImport.update({
            id: '/invitations/$invitationId',path: '/invitations/$invitationId',getParentRoute: () => PublicRouteRoute
          })
const PublicResetPasswordIndexRoute = PublicResetPasswordIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicResetPasswordRouteRoute
          })
const PublicResetPasswordResetIdRoute = PublicResetPasswordResetIdRouteImport.update({
            id: '/$resetId',path: '/$resetId',getParentRoute: () => PublicResetPasswordRouteRoute
          })
const PublicSharedSharedIdRoute = PublicSharedSharedIdRouteImport.update({
            id: '/shared/$sharedId',path: '/shared/$sharedId',getParentRoute: () => PublicRouteRoute
          })
const AuthAdminAdminBillingRouteRoute = AuthAdminAdminBillingRouteRouteImport.update({
            id: '/admin/billing',path: '/admin/billing',getParentRoute: () => AuthAdminRouteRoute
          })
const AuthAdminAdminFeatureFlagsRouteRoute = AuthAdminAdminFeatureFlagsRouteRouteImport.update({
            id: '/admin/feature-flags',path: '/admin/feature-flags',getParentRoute: () => AuthAdminRouteRoute
          })
const AuthAdminAdminInvitationCodesRoute = AuthAdminAdminInvitationCodesRouteImport.update({
            id: '/admin/invitation-codes',path: '/admin/invitation-codes',getParentRoute: () => AuthAdminRouteRoute
          })
const AuthAdminAdminMetricsRouteRoute = AuthAdminAdminMetricsRouteRouteImport.update({
            id: '/admin/metrics',path: '/admin/metrics',getParentRoute: () => AuthAdminRouteRoute
          })
const AuthAdminAdminProductsRoute = AuthAdminAdminProductsRouteImport.update({
            id: '/admin/products',path: '/admin/products',getParentRoute: () => AuthAdminRouteRoute
          })
const AuthAdminAdminStravaWebhookRoute = AuthAdminAdminStravaWebhookRouteImport.update({
            id: '/admin/strava-webhook',path: '/admin/strava-webhook',getParentRoute: () => AuthAdminRouteRoute
          })
const AuthAthleteCalendarIndexRoute = AuthAthleteCalendarIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthAthleteCalendarRouteRoute
          })
const AuthAthleteProgramsIndexRoute = AuthAthleteProgramsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthAthleteProgramsRouteRoute
          })
const AuthAthleteProgramsProgramIdRouteRoute = AuthAthleteProgramsProgramIdRouteRouteImport.update({
            id: '/$programId',path: '/$programId',getParentRoute: () => AuthAthleteProgramsRouteRoute
          })
const AuthAthleteQuestionnaireSubmissionsIndexRoute = AuthAthleteQuestionnaireSubmissionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthAthleteQuestionnaireSubmissionsRouteRoute
          })
const AuthAthleteQuestionnaireSubmissionsSubmissionIdRouteRoute = AuthAthleteQuestionnaireSubmissionsSubmissionIdRouteRouteImport.update({
            id: '/$submissionId',path: '/$submissionId',getParentRoute: () => AuthAthleteQuestionnaireSubmissionsRouteRoute
          })
const AuthCoachAiIndexRoute = AuthCoachAiIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachAiRouteRoute
          })
const AuthCoachAiChatIdRoute = AuthCoachAiChatIdRouteImport.update({
            id: '/$chatId',path: '/$chatId',getParentRoute: () => AuthCoachAiRouteRoute
          })
const AuthCoachAthletesIndexRoute = AuthCoachAthletesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachAthletesRouteRoute
          })
const AuthCoachAthletesAthleteIdRouteRoute = AuthCoachAthletesAthleteIdRouteRouteImport.update({
            id: '/$athleteId',path: '/$athleteId',getParentRoute: () => AuthCoachAthletesRouteRoute
          })
const AuthCoachAutomationsIndexRoute = AuthCoachAutomationsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachAutomationsRouteRoute
          })
const AuthCoachAutomationsAutomationIdRouteRoute = AuthCoachAutomationsAutomationIdRouteRouteImport.update({
            id: '/$automationId',path: '/$automationId',getParentRoute: () => AuthCoachAutomationsRouteRoute
          })
const AuthCoachAutomationsNewRoute = AuthCoachAutomationsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AuthCoachAutomationsRouteRoute
          })
const AuthCoachBundlesIndexRoute = AuthCoachBundlesIndexRouteImport.update({
            id: '/bundles/',path: '/bundles/',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthCoachContentHubIndexRoute = AuthCoachContentHubIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachContentHubRouteRoute
          })
const AuthCoachContentHubContentHubIdRouteRoute = AuthCoachContentHubContentHubIdRouteRouteImport.update({
            id: '/$contentHubId',path: '/$contentHubId',getParentRoute: () => AuthCoachContentHubRouteRoute
          })
const AuthCoachLabelsIndexRoute = AuthCoachLabelsIndexRouteImport.update({
            id: '/labels/',path: '/labels/',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthCoachLibraryIndexRoute = AuthCoachLibraryIndexRouteImport.update({
            id: '/library/',path: '/library/',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthCoachLibraryExercisesRouteRoute = AuthCoachLibraryExercisesRouteRouteImport.update({
            id: '/library/exercises',path: '/library/exercises',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthCoachLibraryProgramsRouteRoute = AuthCoachLibraryProgramsRouteRouteImport.update({
            id: '/library/programs',path: '/library/programs',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthCoachLibrarySectionsRouteRoute = AuthCoachLibrarySectionsRouteRouteImport.update({
            id: '/library/sections',path: '/library/sections',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthCoachLibraryWorkoutsRouteRoute = AuthCoachLibraryWorkoutsRouteRouteImport.update({
            id: '/library/workouts',path: '/library/workouts',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthCoachOrgsSlugRouteRoute = AuthCoachOrgsSlugRouteRouteImport.update({
            id: '/orgs/$slug',path: '/orgs/$slug',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthCoachProductsProductIdRouteRoute = AuthCoachProductsProductIdRouteRouteImport.update({
            id: '/$productId',path: '/$productId',getParentRoute: () => AuthCoachProductsRouteRoute
          })
const AuthCoachProductsTabsRoute = AuthCoachProductsTabsRouteImport.update({
            id: '/_tabs',getParentRoute: () => AuthCoachProductsRouteRoute
          })
const AuthCoachProductsNewRoute = AuthCoachProductsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AuthCoachProductsRouteRoute
          })
const AuthCoachProfileSectionRoute = AuthCoachProfileSectionRouteImport.update({
            id: '/$section',path: '/$section',getParentRoute: () => AuthCoachProfileRouteRoute
          })
const AuthCoachProfileLeadsRoute = AuthCoachProfileLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => AuthCoachProfileRouteRoute
          })
const AuthCoachQuestionnairesIndexRoute = AuthCoachQuestionnairesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachQuestionnairesRouteRoute
          })
const AuthCoachQuestionnairesQuestionnaireIdRouteRoute = AuthCoachQuestionnairesQuestionnaireIdRouteRouteImport.update({
            id: '/$questionnaireId',path: '/$questionnaireId',getParentRoute: () => AuthCoachQuestionnairesRouteRoute
          })
const AuthCoachWorkflowsIndexRoute = AuthCoachWorkflowsIndexRouteImport.update({
            id: '/workflows/',path: '/workflows/',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthCoachWorkflowsWorkflowIdRouteRoute = AuthCoachWorkflowsWorkflowIdRouteRouteImport.update({
            id: '/workflows/$workflowId',path: '/workflows/$workflowId',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthSettingsIntegrationsIndexRoute = AuthSettingsIntegrationsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthSettingsIntegrationsRouteRoute
          })
const AuthSettingsIntegrationsAppleHealthRouteRoute = AuthSettingsIntegrationsAppleHealthRouteRouteImport.update({
            id: '/apple-health',path: '/apple-health',getParentRoute: () => AuthSettingsIntegrationsRouteRoute
          })
const AuthSettingsIntegrationsStravaRouteRoute = AuthSettingsIntegrationsStravaRouteRouteImport.update({
            id: '/strava',path: '/strava',getParentRoute: () => AuthSettingsIntegrationsRouteRoute
          })
const HybridWorkflowWorkflowIdJoinRoute = HybridWorkflowWorkflowIdJoinRouteImport.update({
            id: '/join',path: '/join',getParentRoute: () => HybridWorkflowWorkflowIdRouteRoute
          })
const PublicInvitationsInvitationIdIndexRoute = PublicInvitationsInvitationIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicInvitationsInvitationIdRouteRoute
          })
const CSlugPProductSlugRoute = CSlugPProductSlugRouteImport.update({
            id: '/c/$slug_/p/$productSlug',path: '/c/$slug/p/$productSlug',getParentRoute: () => rootRouteImport
          })
const AuthAdminAdminBillingIndexRoute = AuthAdminAdminBillingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthAdminAdminBillingRouteRoute
          })
const AuthAdminAdminBillingActionsRoute = AuthAdminAdminBillingActionsRouteImport.update({
            id: '/actions',path: '/actions',getParentRoute: () => AuthAdminAdminBillingRouteRoute
          })
const AuthAdminAdminBillingFeaturesRoute = AuthAdminAdminBillingFeaturesRouteImport.update({
            id: '/features',path: '/features',getParentRoute: () => AuthAdminAdminBillingRouteRoute
          })
const AuthAdminAdminFeatureFlagsIndexRoute = AuthAdminAdminFeatureFlagsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthAdminAdminFeatureFlagsRouteRoute
          })
const AuthAdminAdminFeatureFlagsAccessRoute = AuthAdminAdminFeatureFlagsAccessRouteImport.update({
            id: '/access',path: '/access',getParentRoute: () => AuthAdminAdminFeatureFlagsRouteRoute
          })
const AuthAdminAdminMetricsIndexRoute = AuthAdminAdminMetricsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthAdminAdminMetricsRouteRoute
          })
const AuthAdminAdminMetricsIntegrationConfigsRoute = AuthAdminAdminMetricsIntegrationConfigsRouteImport.update({
            id: '/integration-configs',path: '/integration-configs',getParentRoute: () => AuthAdminAdminMetricsRouteRoute
          })
const AuthAthleteQuestionnaireSubmissionsSubmissionIdIndexRoute = AuthAthleteQuestionnaireSubmissionsSubmissionIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthAthleteQuestionnaireSubmissionsSubmissionIdRouteRoute
          })
const AuthCoachAthletesAthleteIdTabsRoute = AuthCoachAthletesAthleteIdTabsRouteImport.update({
            id: '/_tabs',getParentRoute: () => AuthCoachAthletesAthleteIdRouteRoute
          })
const AuthCoachAthletesAthleteIdProgramsRouteRoute = AuthCoachAthletesAthleteIdProgramsRouteRouteImport.update({
            id: '/programs',path: '/programs',getParentRoute: () => AuthCoachAthletesAthleteIdRouteRoute
          })
const AuthCoachAutomationsAutomationIdIndexRoute = AuthCoachAutomationsAutomationIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachAutomationsAutomationIdRouteRoute
          })
const AuthCoachAutomationsAutomationIdRunsRoute = AuthCoachAutomationsAutomationIdRunsRouteImport.update({
            id: '/runs',path: '/runs',getParentRoute: () => AuthCoachAutomationsAutomationIdRouteRoute
          })
const AuthCoachContentHubContentHubIdIndexRoute = AuthCoachContentHubContentHubIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachContentHubContentHubIdRouteRoute
          })
const AuthCoachContentHubContentHubIdSplatRoute = AuthCoachContentHubContentHubIdSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => AuthCoachContentHubContentHubIdRouteRoute
          })
const AuthCoachContentHubContentHubIdAssignedAthletesRoute = AuthCoachContentHubContentHubIdAssignedAthletesRouteImport.update({
            id: '/assigned-athletes',path: '/assigned-athletes',getParentRoute: () => AuthCoachContentHubContentHubIdRouteRoute
          })
const AuthCoachLibraryExercisesIndexRoute = AuthCoachLibraryExercisesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachLibraryExercisesRouteRoute
          })
const AuthCoachLibraryExercisesExerciseIdRoute = AuthCoachLibraryExercisesExerciseIdRouteImport.update({
            id: '/$exerciseId',path: '/$exerciseId',getParentRoute: () => AuthCoachLibraryExercisesRouteRoute
          })
const AuthCoachLibraryProgramsIndexRoute = AuthCoachLibraryProgramsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachLibraryProgramsRouteRoute
          })
const AuthCoachLibraryProgramsProgramIdRouteRoute = AuthCoachLibraryProgramsProgramIdRouteRouteImport.update({
            id: '/$programId',path: '/$programId',getParentRoute: () => AuthCoachLibraryProgramsRouteRoute
          })
const AuthCoachLibraryResourcesIndexRoute = AuthCoachLibraryResourcesIndexRouteImport.update({
            id: '/library/resources/',path: '/library/resources/',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthCoachLibrarySectionsIndexRoute = AuthCoachLibrarySectionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachLibrarySectionsRouteRoute
          })
const AuthCoachLibraryTasksIndexRoute = AuthCoachLibraryTasksIndexRouteImport.update({
            id: '/library/tasks/',path: '/library/tasks/',getParentRoute: () => AuthCoachRouteRoute
          })
const AuthCoachLibraryWorkoutsIndexRoute = AuthCoachLibraryWorkoutsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachLibraryWorkoutsRouteRoute
          })
const AuthCoachLibraryWorkoutsWorkoutIdRoute = AuthCoachLibraryWorkoutsWorkoutIdRouteImport.update({
            id: '/$workoutId',path: '/$workoutId',getParentRoute: () => AuthCoachLibraryWorkoutsRouteRoute
          })
const AuthCoachOrgsSlugIndexRoute = AuthCoachOrgsSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachOrgsSlugRouteRoute
          })
const AuthCoachOrgsSlugAthletesRouteRoute = AuthCoachOrgsSlugAthletesRouteRouteImport.update({
            id: '/athletes',path: '/athletes',getParentRoute: () => AuthCoachOrgsSlugRouteRoute
          })
const AuthCoachOrgsSlugExercisesRouteRoute = AuthCoachOrgsSlugExercisesRouteRouteImport.update({
            id: '/exercises',path: '/exercises',getParentRoute: () => AuthCoachOrgsSlugRouteRoute
          })
const AuthCoachOrgsSlugProgramsRouteRoute = AuthCoachOrgsSlugProgramsRouteRouteImport.update({
            id: '/programs',path: '/programs',getParentRoute: () => AuthCoachOrgsSlugRouteRoute
          })
const AuthCoachOrgsSlugSettingsRouteRoute = AuthCoachOrgsSlugSettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthCoachOrgsSlugRouteRoute
          })
const AuthCoachOrgsSlugWorkoutsRouteRoute = AuthCoachOrgsSlugWorkoutsRouteRouteImport.update({
            id: '/workouts',path: '/workouts',getParentRoute: () => AuthCoachOrgsSlugRouteRoute
          })
const AuthCoachProductsProductIdTabsRoute = AuthCoachProductsProductIdTabsRouteImport.update({
            id: '/_tabs',getParentRoute: () => AuthCoachProductsProductIdRouteRoute
          })
const AuthCoachProductsProductIdAutomationsRouteRoute = AuthCoachProductsProductIdAutomationsRouteRouteImport.update({
            id: '/automations',path: '/automations',getParentRoute: () => AuthCoachProductsProductIdRouteRoute
          })
const AuthCoachProductsTabsIndexRoute = AuthCoachProductsTabsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachProductsTabsRoute
          })
const AuthCoachProductsTabsInvoicingRoute = AuthCoachProductsTabsInvoicingRouteImport.update({
            id: '/invoicing',path: '/invoicing',getParentRoute: () => AuthCoachProductsTabsRoute
          })
const AuthCoachProductsTabsPaymentSetupRoute = AuthCoachProductsTabsPaymentSetupRouteImport.update({
            id: '/payment-setup',path: '/payment-setup',getParentRoute: () => AuthCoachProductsTabsRoute
          })
const AuthCoachProductsTabsPromoCodesRoute = AuthCoachProductsTabsPromoCodesRouteImport.update({
            id: '/promo-codes',path: '/promo-codes',getParentRoute: () => AuthCoachProductsTabsRoute
          })
const AuthCoachProductsTabsSalesRoute = AuthCoachProductsTabsSalesRouteImport.update({
            id: '/sales',path: '/sales',getParentRoute: () => AuthCoachProductsTabsRoute
          })
const AuthCoachProductsTabsSubscriptionsRoute = AuthCoachProductsTabsSubscriptionsRouteImport.update({
            id: '/subscriptions',path: '/subscriptions',getParentRoute: () => AuthCoachProductsTabsRoute
          })
const AuthCoachQuestionnairesQuestionnaireIdIndexRoute = AuthCoachQuestionnairesQuestionnaireIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachQuestionnairesQuestionnaireIdRouteRoute
          })
const AuthCoachQuestionnairesQuestionnaireIdSubmissionsRouteRoute = AuthCoachQuestionnairesQuestionnaireIdSubmissionsRouteRouteImport.update({
            id: '/submissions',path: '/submissions',getParentRoute: () => AuthCoachQuestionnairesQuestionnaireIdRouteRoute
          })
const AuthCoachWorkflowsWorkflowIdIndexRoute = AuthCoachWorkflowsWorkflowIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachWorkflowsWorkflowIdRouteRoute
          })
const AuthCoachWorkflowsWorkflowIdAthletesRoute = AuthCoachWorkflowsWorkflowIdAthletesRouteImport.update({
            id: '/athletes',path: '/athletes',getParentRoute: () => AuthCoachWorkflowsWorkflowIdRouteRoute
          })
const AuthCoachWorkflowsWorkflowIdScheduleRoute = AuthCoachWorkflowsWorkflowIdScheduleRouteImport.update({
            id: '/schedule',path: '/schedule',getParentRoute: () => AuthCoachWorkflowsWorkflowIdRouteRoute
          })
const AuthCoachWorkflowsWorkflowIdSettingsRoute = AuthCoachWorkflowsWorkflowIdSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthCoachWorkflowsWorkflowIdRouteRoute
          })
const AuthSettingsIntegrationsAppleHealthIndexRoute = AuthSettingsIntegrationsAppleHealthIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthSettingsIntegrationsAppleHealthRouteRoute
          })
const AuthSettingsIntegrationsStravaIndexRoute = AuthSettingsIntegrationsStravaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthSettingsIntegrationsStravaRouteRoute
          })
const AuthSettingsIntegrationsStravaActivitiesRoute = AuthSettingsIntegrationsStravaActivitiesRouteImport.update({
            id: '/activities',path: '/activities',getParentRoute: () => AuthSettingsIntegrationsStravaRouteRoute
          })
const CSlugPProductSlugSuccessRoute = CSlugPProductSlugSuccessRouteImport.update({
            id: '/c/$slug_/p/$productSlug_/success',path: '/c/$slug/p/$productSlug/success',getParentRoute: () => rootRouteImport
          })
const AuthCoachAthletesAthleteIdTabsPaymentsRoute = AuthCoachAthletesAthleteIdTabsPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => AuthCoachAthletesAthleteIdTabsRoute
          })
const AuthCoachAthletesAthleteIdTabsProfileRoute = AuthCoachAthletesAthleteIdTabsProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthCoachAthletesAthleteIdTabsRoute
          })
const AuthCoachAthletesAthleteIdTabsStatisticsRoute = AuthCoachAthletesAthleteIdTabsStatisticsRouteImport.update({
            id: '/statistics',path: '/statistics',getParentRoute: () => AuthCoachAthletesAthleteIdTabsRoute
          })
const AuthCoachAthletesAthleteIdProgramsProgramIdRouteRoute = AuthCoachAthletesAthleteIdProgramsProgramIdRouteRouteImport.update({
            id: '/$programId',path: '/$programId',getParentRoute: () => AuthCoachAthletesAthleteIdProgramsRouteRoute
          })
const AuthCoachAthletesAthleteIdProgramsTabsRoute = AuthCoachAthletesAthleteIdProgramsTabsRouteImport.update({
            id: '/_tabs',getParentRoute: () => AuthCoachAthletesAthleteIdProgramsRouteRoute
          })
const AuthCoachLibraryProgramsProgramIdIndexRoute = AuthCoachLibraryProgramsProgramIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachLibraryProgramsProgramIdRouteRoute
          })
const AuthCoachLibraryProgramsProgramIdSharedRouteRoute = AuthCoachLibraryProgramsProgramIdSharedRouteRouteImport.update({
            id: '/shared',path: '/shared',getParentRoute: () => AuthCoachLibraryProgramsProgramIdRouteRoute
          })
const AuthCoachOrgsSlugAthletesIndexRoute = AuthCoachOrgsSlugAthletesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachOrgsSlugAthletesRouteRoute
          })
const AuthCoachOrgsSlugAthletesAthleteIdRouteRoute = AuthCoachOrgsSlugAthletesAthleteIdRouteRouteImport.update({
            id: '/$athleteId',path: '/$athleteId',getParentRoute: () => AuthCoachOrgsSlugAthletesRouteRoute
          })
const AuthCoachOrgsSlugExercisesIndexRoute = AuthCoachOrgsSlugExercisesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachOrgsSlugExercisesRouteRoute
          })
const AuthCoachOrgsSlugExercisesExerciseIdRoute = AuthCoachOrgsSlugExercisesExerciseIdRouteImport.update({
            id: '/$exerciseId',path: '/$exerciseId',getParentRoute: () => AuthCoachOrgsSlugExercisesRouteRoute
          })
const AuthCoachOrgsSlugLabelsIndexRoute = AuthCoachOrgsSlugLabelsIndexRouteImport.update({
            id: '/labels/',path: '/labels/',getParentRoute: () => AuthCoachOrgsSlugRouteRoute
          })
const AuthCoachOrgsSlugProgramsIndexRoute = AuthCoachOrgsSlugProgramsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachOrgsSlugProgramsRouteRoute
          })
const AuthCoachOrgsSlugSettingsIndexRoute = AuthCoachOrgsSlugSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachOrgsSlugSettingsRouteRoute
          })
const AuthCoachOrgsSlugSettingsBillingRoute = AuthCoachOrgsSlugSettingsBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AuthCoachOrgsSlugSettingsRouteRoute
          })
const AuthCoachOrgsSlugSettingsIntegrationsRouteRoute = AuthCoachOrgsSlugSettingsIntegrationsRouteRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => AuthCoachOrgsSlugSettingsRouteRoute
          })
const AuthCoachOrgsSlugSettingsMcpRoute = AuthCoachOrgsSlugSettingsMcpRouteImport.update({
            id: '/mcp',path: '/mcp',getParentRoute: () => AuthCoachOrgsSlugSettingsRouteRoute
          })
const AuthCoachOrgsSlugSettingsMembersRoute = AuthCoachOrgsSlugSettingsMembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => AuthCoachOrgsSlugSettingsRouteRoute
          })
const AuthCoachOrgsSlugSettingsPreferencesRoute = AuthCoachOrgsSlugSettingsPreferencesRouteImport.update({
            id: '/preferences',path: '/preferences',getParentRoute: () => AuthCoachOrgsSlugSettingsRouteRoute
          })
const AuthCoachOrgsSlugSettingsProfileRoute = AuthCoachOrgsSlugSettingsProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthCoachOrgsSlugSettingsRouteRoute
          })
const AuthCoachOrgsSlugWorkoutsIndexRoute = AuthCoachOrgsSlugWorkoutsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachOrgsSlugWorkoutsRouteRoute
          })
const AuthCoachProductsProductIdTabsIndexRoute = AuthCoachProductsProductIdTabsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachProductsProductIdTabsRoute
          })
const AuthCoachProductsProductIdAutomationsAutomationIdRouteRoute = AuthCoachProductsProductIdAutomationsAutomationIdRouteRouteImport.update({
            id: '/$automationId',path: '/$automationId',getParentRoute: () => AuthCoachProductsProductIdAutomationsRouteRoute
          })
const AuthCoachProductsProductIdAutomationsTabsRoute = AuthCoachProductsProductIdAutomationsTabsRouteImport.update({
            id: '/_tabs',getParentRoute: () => AuthCoachProductsProductIdAutomationsRouteRoute
          })
const AuthCoachProductsProductIdAutomationsNewRoute = AuthCoachProductsProductIdAutomationsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AuthCoachProductsProductIdAutomationsRouteRoute
          })
const AuthCoachQuestionnairesQuestionnaireIdSubmissionsIndexRoute = AuthCoachQuestionnairesQuestionnaireIdSubmissionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachQuestionnairesQuestionnaireIdSubmissionsRouteRoute
          })
const AuthCoachQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRoute = AuthCoachQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRouteImport.update({
            id: '/$submissionId',path: '/$submissionId',getParentRoute: () => AuthCoachQuestionnairesQuestionnaireIdSubmissionsRouteRoute
          })
const AuthCoachAthletesAthleteIdTabsCalendarIndexRoute = AuthCoachAthletesAthleteIdTabsCalendarIndexRouteImport.update({
            id: '/calendar/',path: '/calendar/',getParentRoute: () => AuthCoachAthletesAthleteIdTabsRoute
          })
const AuthCoachAthletesAthleteIdTabsCalendarCalendarItemIdRoute = AuthCoachAthletesAthleteIdTabsCalendarCalendarItemIdRouteImport.update({
            id: '/calendar/$calendarItemId',path: '/calendar/$calendarItemId',getParentRoute: () => AuthCoachAthletesAthleteIdTabsRoute
          })
const AuthCoachAthletesAthleteIdTabsMetricsIndexRoute = AuthCoachAthletesAthleteIdTabsMetricsIndexRouteImport.update({
            id: '/metrics/',path: '/metrics/',getParentRoute: () => AuthCoachAthletesAthleteIdTabsRoute
          })
const AuthCoachAthletesAthleteIdTabsQuestionnairesIndexRoute = AuthCoachAthletesAthleteIdTabsQuestionnairesIndexRouteImport.update({
            id: '/questionnaires/',path: '/questionnaires/',getParentRoute: () => AuthCoachAthletesAthleteIdTabsRoute
          })
const AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRoute = AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRouteImport.update({
            id: '/questionnaires/$questionnaireId',path: '/questionnaires/$questionnaireId',getParentRoute: () => AuthCoachAthletesAthleteIdTabsRoute
          })
const AuthCoachAthletesAthleteIdProgramsProgramIdIndexRoute = AuthCoachAthletesAthleteIdProgramsProgramIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachAthletesAthleteIdProgramsProgramIdRouteRoute
          })
const AuthCoachAthletesAthleteIdProgramsTabsIndexRoute = AuthCoachAthletesAthleteIdProgramsTabsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachAthletesAthleteIdProgramsTabsRoute
          })
const AuthCoachLibraryProgramsProgramIdSharedIndexRoute = AuthCoachLibraryProgramsProgramIdSharedIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachLibraryProgramsProgramIdSharedRouteRoute
          })
const AuthCoachLibraryProgramsProgramIdSharedSharedProgramIdRouteRoute = AuthCoachLibraryProgramsProgramIdSharedSharedProgramIdRouteRouteImport.update({
            id: '/$sharedProgramId',path: '/$sharedProgramId',getParentRoute: () => AuthCoachLibraryProgramsProgramIdSharedRouteRoute
          })
const AuthCoachOrgsSlugAthletesAthleteIdIndexRoute = AuthCoachOrgsSlugAthletesAthleteIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachOrgsSlugAthletesAthleteIdRouteRoute
          })
const AuthCoachOrgsSlugAthletesAthleteIdTabsRoute = AuthCoachOrgsSlugAthletesAthleteIdTabsRouteImport.update({
            id: '/_tabs',getParentRoute: () => AuthCoachOrgsSlugAthletesAthleteIdRouteRoute
          })
const AuthCoachOrgsSlugSettingsIntegrationsIndexRoute = AuthCoachOrgsSlugSettingsIntegrationsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachOrgsSlugSettingsIntegrationsRouteRoute
          })
const AuthCoachOrgsSlugSettingsIntegrationsAppleHealthRouteRoute = AuthCoachOrgsSlugSettingsIntegrationsAppleHealthRouteRouteImport.update({
            id: '/apple-health',path: '/apple-health',getParentRoute: () => AuthCoachOrgsSlugSettingsIntegrationsRouteRoute
          })
const AuthCoachOrgsSlugSettingsIntegrationsStravaRouteRoute = AuthCoachOrgsSlugSettingsIntegrationsStravaRouteRouteImport.update({
            id: '/strava',path: '/strava',getParentRoute: () => AuthCoachOrgsSlugSettingsIntegrationsRouteRoute
          })
const AuthCoachProductsProductIdAutomationsAutomationIdIndexRoute = AuthCoachProductsProductIdAutomationsAutomationIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachProductsProductIdAutomationsAutomationIdRouteRoute
          })
const AuthCoachProductsProductIdAutomationsAutomationIdRunsRoute = AuthCoachProductsProductIdAutomationsAutomationIdRunsRouteImport.update({
            id: '/runs',path: '/runs',getParentRoute: () => AuthCoachProductsProductIdAutomationsAutomationIdRouteRoute
          })
const AuthCoachProductsProductIdAutomationsTabsIndexRoute = AuthCoachProductsProductIdAutomationsTabsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachProductsProductIdAutomationsTabsRoute
          })
const AuthCoachQuestionnairesQuestionnaireIdSubmissionsSubmissionIdIndexRoute = AuthCoachQuestionnairesQuestionnaireIdSubmissionsSubmissionIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRoute
          })
const AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdIndexRoute = AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRoute
          })
const AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRoute = AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRouteImport.update({
            id: '/submissions',path: '/submissions',getParentRoute: () => AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRoute
          })
const AuthCoachLibraryProgramsProgramIdSharedSharedProgramIdIndexRoute = AuthCoachLibraryProgramsProgramIdSharedSharedProgramIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachLibraryProgramsProgramIdSharedSharedProgramIdRouteRoute
          })
const AuthCoachOrgsSlugAthletesAthleteIdTabsProfileRoute = AuthCoachOrgsSlugAthletesAthleteIdTabsProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthCoachOrgsSlugAthletesAthleteIdTabsRoute
          })
const AuthCoachOrgsSlugAthletesAthleteIdTabsStatisticsRoute = AuthCoachOrgsSlugAthletesAthleteIdTabsStatisticsRouteImport.update({
            id: '/statistics',path: '/statistics',getParentRoute: () => AuthCoachOrgsSlugAthletesAthleteIdTabsRoute
          })
const AuthCoachOrgsSlugSettingsIntegrationsAppleHealthIndexRoute = AuthCoachOrgsSlugSettingsIntegrationsAppleHealthIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachOrgsSlugSettingsIntegrationsAppleHealthRouteRoute
          })
const AuthCoachOrgsSlugSettingsIntegrationsStravaIndexRoute = AuthCoachOrgsSlugSettingsIntegrationsStravaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachOrgsSlugSettingsIntegrationsStravaRouteRoute
          })
const AuthCoachOrgsSlugSettingsIntegrationsStravaActivitiesRoute = AuthCoachOrgsSlugSettingsIntegrationsStravaActivitiesRouteImport.update({
            id: '/activities',path: '/activities',getParentRoute: () => AuthCoachOrgsSlugSettingsIntegrationsStravaRouteRoute
          })
const AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsIndexRoute = AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRoute
          })
const AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRoute = AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRouteImport.update({
            id: '/$submissionId',path: '/$submissionId',getParentRoute: () => AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRoute
          })
const AuthCoachOrgsSlugAthletesAthleteIdTabsMetricsIndexRoute = AuthCoachOrgsSlugAthletesAthleteIdTabsMetricsIndexRouteImport.update({
            id: '/metrics/',path: '/metrics/',getParentRoute: () => AuthCoachOrgsSlugAthletesAthleteIdTabsRoute
          })
const AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesIndexRoute = AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesIndexRouteImport.update({
            id: '/questionnaires/',path: '/questionnaires/',getParentRoute: () => AuthCoachOrgsSlugAthletesAthleteIdTabsRoute
          })
const AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRoute = AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRouteImport.update({
            id: '/questionnaires/$questionnaireId',path: '/questionnaires/$questionnaireId',getParentRoute: () => AuthCoachOrgsSlugAthletesAthleteIdTabsRoute
          })
const AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdIndexRoute = AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRoute
          })
const AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdIndexRoute = AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRoute
          })
const AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRoute = AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRouteImport.update({
            id: '/submissions',path: '/submissions',getParentRoute: () => AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRoute
          })
const AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsIndexRoute = AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRoute
          })
const AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRoute = AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRouteImport.update({
            id: '/$submissionId',path: '/$submissionId',getParentRoute: () => AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRoute
          })
const AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdIndexRoute = AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRoute
          })





const AuthAdminAdminBillingRouteRouteChildren = {
  AuthAdminAdminBillingActionsRoute: AuthAdminAdminBillingActionsRoute,AuthAdminAdminBillingFeaturesRoute: AuthAdminAdminBillingFeaturesRoute,AuthAdminAdminBillingIndexRoute: AuthAdminAdminBillingIndexRoute
}

const AuthAdminAdminBillingRouteRouteWithChildren = AuthAdminAdminBillingRouteRoute._addFileChildren(AuthAdminAdminBillingRouteRouteChildren)




const AuthAdminAdminFeatureFlagsRouteRouteChildren = {
  AuthAdminAdminFeatureFlagsAccessRoute: AuthAdminAdminFeatureFlagsAccessRoute,AuthAdminAdminFeatureFlagsIndexRoute: AuthAdminAdminFeatureFlagsIndexRoute
}

const AuthAdminAdminFeatureFlagsRouteRouteWithChildren = AuthAdminAdminFeatureFlagsRouteRoute._addFileChildren(AuthAdminAdminFeatureFlagsRouteRouteChildren)




const AuthAdminAdminMetricsRouteRouteChildren = {
  AuthAdminAdminMetricsIntegrationConfigsRoute: AuthAdminAdminMetricsIntegrationConfigsRoute,AuthAdminAdminMetricsIndexRoute: AuthAdminAdminMetricsIndexRoute
}

const AuthAdminAdminMetricsRouteRouteWithChildren = AuthAdminAdminMetricsRouteRoute._addFileChildren(AuthAdminAdminMetricsRouteRouteChildren)



const AuthAdminRouteRouteChildren = {
  AuthAdminAdminBillingRouteRoute: AuthAdminAdminBillingRouteRouteWithChildren,AuthAdminAdminFeatureFlagsRouteRoute: AuthAdminAdminFeatureFlagsRouteRouteWithChildren,AuthAdminAdminMetricsRouteRoute: AuthAdminAdminMetricsRouteRouteWithChildren,AuthAdminAdminInvitationCodesRoute: AuthAdminAdminInvitationCodesRoute,AuthAdminAdminProductsRoute: AuthAdminAdminProductsRoute,AuthAdminAdminStravaWebhookRoute: AuthAdminAdminStravaWebhookRoute
}

const AuthAdminRouteRouteWithChildren = AuthAdminRouteRoute._addFileChildren(AuthAdminRouteRouteChildren)




const AuthAthleteCalendarRouteRouteChildren = {
  AuthAthleteCalendarIndexRoute: AuthAthleteCalendarIndexRoute
}

const AuthAthleteCalendarRouteRouteWithChildren = AuthAthleteCalendarRouteRoute._addFileChildren(AuthAthleteCalendarRouteRouteChildren)




const AuthAthleteProgramsRouteRouteChildren = {
  AuthAthleteProgramsProgramIdRouteRoute: AuthAthleteProgramsProgramIdRouteRoute,AuthAthleteProgramsIndexRoute: AuthAthleteProgramsIndexRoute
}

const AuthAthleteProgramsRouteRouteWithChildren = AuthAthleteProgramsRouteRoute._addFileChildren(AuthAthleteProgramsRouteRouteChildren)




const AuthAthleteQuestionnaireSubmissionsSubmissionIdRouteRouteChildren = {
  AuthAthleteQuestionnaireSubmissionsSubmissionIdIndexRoute: AuthAthleteQuestionnaireSubmissionsSubmissionIdIndexRoute
}

const AuthAthleteQuestionnaireSubmissionsSubmissionIdRouteRouteWithChildren = AuthAthleteQuestionnaireSubmissionsSubmissionIdRouteRoute._addFileChildren(AuthAthleteQuestionnaireSubmissionsSubmissionIdRouteRouteChildren)



const AuthAthleteQuestionnaireSubmissionsRouteRouteChildren = {
  AuthAthleteQuestionnaireSubmissionsSubmissionIdRouteRoute: AuthAthleteQuestionnaireSubmissionsSubmissionIdRouteRouteWithChildren,AuthAthleteQuestionnaireSubmissionsIndexRoute: AuthAthleteQuestionnaireSubmissionsIndexRoute
}

const AuthAthleteQuestionnaireSubmissionsRouteRouteWithChildren = AuthAthleteQuestionnaireSubmissionsRouteRoute._addFileChildren(AuthAthleteQuestionnaireSubmissionsRouteRouteChildren)



const AuthAthleteRouteRouteChildren = {
  AuthAthleteCalendarRouteRoute: AuthAthleteCalendarRouteRouteWithChildren,AuthAthleteProgramsRouteRoute: AuthAthleteProgramsRouteRouteWithChildren,AuthAthleteQuestionnaireSubmissionsRouteRoute: AuthAthleteQuestionnaireSubmissionsRouteRouteWithChildren,AuthAthletePaymentsRoute: AuthAthletePaymentsRoute
}

const AuthAthleteRouteRouteWithChildren = AuthAthleteRouteRoute._addFileChildren(AuthAthleteRouteRouteChildren)




const AuthCoachAiRouteRouteChildren = {
  AuthCoachAiChatIdRoute: AuthCoachAiChatIdRoute,AuthCoachAiIndexRoute: AuthCoachAiIndexRoute
}

const AuthCoachAiRouteRouteWithChildren = AuthCoachAiRouteRoute._addFileChildren(AuthCoachAiRouteRouteChildren)




const AuthCoachAthletesAthleteIdProgramsProgramIdRouteRouteChildren = {
  AuthCoachAthletesAthleteIdProgramsProgramIdIndexRoute: AuthCoachAthletesAthleteIdProgramsProgramIdIndexRoute
}

const AuthCoachAthletesAthleteIdProgramsProgramIdRouteRouteWithChildren = AuthCoachAthletesAthleteIdProgramsProgramIdRouteRoute._addFileChildren(AuthCoachAthletesAthleteIdProgramsProgramIdRouteRouteChildren)




const AuthCoachAthletesAthleteIdProgramsTabsRouteChildren = {
  AuthCoachAthletesAthleteIdProgramsTabsIndexRoute: AuthCoachAthletesAthleteIdProgramsTabsIndexRoute
}

const AuthCoachAthletesAthleteIdProgramsTabsRouteWithChildren = AuthCoachAthletesAthleteIdProgramsTabsRoute._addFileChildren(AuthCoachAthletesAthleteIdProgramsTabsRouteChildren)



const AuthCoachAthletesAthleteIdProgramsRouteRouteChildren = {
  AuthCoachAthletesAthleteIdProgramsProgramIdRouteRoute: AuthCoachAthletesAthleteIdProgramsProgramIdRouteRouteWithChildren,AuthCoachAthletesAthleteIdProgramsTabsRoute: AuthCoachAthletesAthleteIdProgramsTabsRouteWithChildren
}

const AuthCoachAthletesAthleteIdProgramsRouteRouteWithChildren = AuthCoachAthletesAthleteIdProgramsRouteRoute._addFileChildren(AuthCoachAthletesAthleteIdProgramsRouteRouteChildren)




const AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRouteChildren = {
  AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdIndexRoute: AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdIndexRoute
}

const AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRouteWithChildren = AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRoute._addFileChildren(AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRouteChildren)



const AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRouteChildren = {
  AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRoute: AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRouteWithChildren,AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsIndexRoute: AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsIndexRoute
}

const AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRouteWithChildren = AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRoute._addFileChildren(AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRouteChildren)



const AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRouteChildren = {
  AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRoute: AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRouteWithChildren,AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdIndexRoute: AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdIndexRoute
}

const AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRouteWithChildren = AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRoute._addFileChildren(AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRouteChildren)



const AuthCoachAthletesAthleteIdTabsRouteChildren = {
  AuthCoachAthletesAthleteIdTabsPaymentsRoute: AuthCoachAthletesAthleteIdTabsPaymentsRoute,AuthCoachAthletesAthleteIdTabsProfileRoute: AuthCoachAthletesAthleteIdTabsProfileRoute,AuthCoachAthletesAthleteIdTabsStatisticsRoute: AuthCoachAthletesAthleteIdTabsStatisticsRoute,AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRoute: AuthCoachAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRouteWithChildren,AuthCoachAthletesAthleteIdTabsCalendarCalendarItemIdRoute: AuthCoachAthletesAthleteIdTabsCalendarCalendarItemIdRoute,AuthCoachAthletesAthleteIdTabsCalendarIndexRoute: AuthCoachAthletesAthleteIdTabsCalendarIndexRoute,AuthCoachAthletesAthleteIdTabsMetricsIndexRoute: AuthCoachAthletesAthleteIdTabsMetricsIndexRoute,AuthCoachAthletesAthleteIdTabsQuestionnairesIndexRoute: AuthCoachAthletesAthleteIdTabsQuestionnairesIndexRoute
}

const AuthCoachAthletesAthleteIdTabsRouteWithChildren = AuthCoachAthletesAthleteIdTabsRoute._addFileChildren(AuthCoachAthletesAthleteIdTabsRouteChildren)



const AuthCoachAthletesAthleteIdRouteRouteChildren = {
  AuthCoachAthletesAthleteIdProgramsRouteRoute: AuthCoachAthletesAthleteIdProgramsRouteRouteWithChildren,AuthCoachAthletesAthleteIdTabsRoute: AuthCoachAthletesAthleteIdTabsRouteWithChildren
}

const AuthCoachAthletesAthleteIdRouteRouteWithChildren = AuthCoachAthletesAthleteIdRouteRoute._addFileChildren(AuthCoachAthletesAthleteIdRouteRouteChildren)



const AuthCoachAthletesRouteRouteChildren = {
  AuthCoachAthletesAthleteIdRouteRoute: AuthCoachAthletesAthleteIdRouteRouteWithChildren,AuthCoachAthletesIndexRoute: AuthCoachAthletesIndexRoute
}

const AuthCoachAthletesRouteRouteWithChildren = AuthCoachAthletesRouteRoute._addFileChildren(AuthCoachAthletesRouteRouteChildren)




const AuthCoachAutomationsAutomationIdRouteRouteChildren = {
  AuthCoachAutomationsAutomationIdRunsRoute: AuthCoachAutomationsAutomationIdRunsRoute,AuthCoachAutomationsAutomationIdIndexRoute: AuthCoachAutomationsAutomationIdIndexRoute
}

const AuthCoachAutomationsAutomationIdRouteRouteWithChildren = AuthCoachAutomationsAutomationIdRouteRoute._addFileChildren(AuthCoachAutomationsAutomationIdRouteRouteChildren)



const AuthCoachAutomationsRouteRouteChildren = {
  AuthCoachAutomationsAutomationIdRouteRoute: AuthCoachAutomationsAutomationIdRouteRouteWithChildren,AuthCoachAutomationsNewRoute: AuthCoachAutomationsNewRoute,AuthCoachAutomationsIndexRoute: AuthCoachAutomationsIndexRoute
}

const AuthCoachAutomationsRouteRouteWithChildren = AuthCoachAutomationsRouteRoute._addFileChildren(AuthCoachAutomationsRouteRouteChildren)




const AuthCoachContentHubContentHubIdRouteRouteChildren = {
  AuthCoachContentHubContentHubIdSplatRoute: AuthCoachContentHubContentHubIdSplatRoute,AuthCoachContentHubContentHubIdAssignedAthletesRoute: AuthCoachContentHubContentHubIdAssignedAthletesRoute,AuthCoachContentHubContentHubIdIndexRoute: AuthCoachContentHubContentHubIdIndexRoute
}

const AuthCoachContentHubContentHubIdRouteRouteWithChildren = AuthCoachContentHubContentHubIdRouteRoute._addFileChildren(AuthCoachContentHubContentHubIdRouteRouteChildren)



const AuthCoachContentHubRouteRouteChildren = {
  AuthCoachContentHubContentHubIdRouteRoute: AuthCoachContentHubContentHubIdRouteRouteWithChildren,AuthCoachContentHubIndexRoute: AuthCoachContentHubIndexRoute
}

const AuthCoachContentHubRouteRouteWithChildren = AuthCoachContentHubRouteRoute._addFileChildren(AuthCoachContentHubRouteRouteChildren)




const AuthCoachProductsProductIdAutomationsAutomationIdRouteRouteChildren = {
  AuthCoachProductsProductIdAutomationsAutomationIdRunsRoute: AuthCoachProductsProductIdAutomationsAutomationIdRunsRoute,AuthCoachProductsProductIdAutomationsAutomationIdIndexRoute: AuthCoachProductsProductIdAutomationsAutomationIdIndexRoute
}

const AuthCoachProductsProductIdAutomationsAutomationIdRouteRouteWithChildren = AuthCoachProductsProductIdAutomationsAutomationIdRouteRoute._addFileChildren(AuthCoachProductsProductIdAutomationsAutomationIdRouteRouteChildren)




const AuthCoachProductsProductIdAutomationsTabsRouteChildren = {
  AuthCoachProductsProductIdAutomationsTabsIndexRoute: AuthCoachProductsProductIdAutomationsTabsIndexRoute
}

const AuthCoachProductsProductIdAutomationsTabsRouteWithChildren = AuthCoachProductsProductIdAutomationsTabsRoute._addFileChildren(AuthCoachProductsProductIdAutomationsTabsRouteChildren)



const AuthCoachProductsProductIdAutomationsRouteRouteChildren = {
  AuthCoachProductsProductIdAutomationsAutomationIdRouteRoute: AuthCoachProductsProductIdAutomationsAutomationIdRouteRouteWithChildren,AuthCoachProductsProductIdAutomationsTabsRoute: AuthCoachProductsProductIdAutomationsTabsRouteWithChildren,AuthCoachProductsProductIdAutomationsNewRoute: AuthCoachProductsProductIdAutomationsNewRoute
}

const AuthCoachProductsProductIdAutomationsRouteRouteWithChildren = AuthCoachProductsProductIdAutomationsRouteRoute._addFileChildren(AuthCoachProductsProductIdAutomationsRouteRouteChildren)




const AuthCoachProductsProductIdTabsRouteChildren = {
  AuthCoachProductsProductIdTabsIndexRoute: AuthCoachProductsProductIdTabsIndexRoute
}

const AuthCoachProductsProductIdTabsRouteWithChildren = AuthCoachProductsProductIdTabsRoute._addFileChildren(AuthCoachProductsProductIdTabsRouteChildren)



const AuthCoachProductsProductIdRouteRouteChildren = {
  AuthCoachProductsProductIdAutomationsRouteRoute: AuthCoachProductsProductIdAutomationsRouteRouteWithChildren,AuthCoachProductsProductIdTabsRoute: AuthCoachProductsProductIdTabsRouteWithChildren
}

const AuthCoachProductsProductIdRouteRouteWithChildren = AuthCoachProductsProductIdRouteRoute._addFileChildren(AuthCoachProductsProductIdRouteRouteChildren)




const AuthCoachProductsTabsRouteChildren = {
  AuthCoachProductsTabsInvoicingRoute: AuthCoachProductsTabsInvoicingRoute,AuthCoachProductsTabsPaymentSetupRoute: AuthCoachProductsTabsPaymentSetupRoute,AuthCoachProductsTabsPromoCodesRoute: AuthCoachProductsTabsPromoCodesRoute,AuthCoachProductsTabsSalesRoute: AuthCoachProductsTabsSalesRoute,AuthCoachProductsTabsSubscriptionsRoute: AuthCoachProductsTabsSubscriptionsRoute,AuthCoachProductsTabsIndexRoute: AuthCoachProductsTabsIndexRoute
}

const AuthCoachProductsTabsRouteWithChildren = AuthCoachProductsTabsRoute._addFileChildren(AuthCoachProductsTabsRouteChildren)



const AuthCoachProductsRouteRouteChildren = {
  AuthCoachProductsProductIdRouteRoute: AuthCoachProductsProductIdRouteRouteWithChildren,AuthCoachProductsTabsRoute: AuthCoachProductsTabsRouteWithChildren,AuthCoachProductsNewRoute: AuthCoachProductsNewRoute
}

const AuthCoachProductsRouteRouteWithChildren = AuthCoachProductsRouteRoute._addFileChildren(AuthCoachProductsRouteRouteChildren)




const AuthCoachProfileRouteRouteChildren = {
  AuthCoachProfileSectionRoute: AuthCoachProfileSectionRoute,AuthCoachProfileLeadsRoute: AuthCoachProfileLeadsRoute
}

const AuthCoachProfileRouteRouteWithChildren = AuthCoachProfileRouteRoute._addFileChildren(AuthCoachProfileRouteRouteChildren)




const AuthCoachQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRouteChildren = {
  AuthCoachQuestionnairesQuestionnaireIdSubmissionsSubmissionIdIndexRoute: AuthCoachQuestionnairesQuestionnaireIdSubmissionsSubmissionIdIndexRoute
}

const AuthCoachQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRouteWithChildren = AuthCoachQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRoute._addFileChildren(AuthCoachQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRouteChildren)



const AuthCoachQuestionnairesQuestionnaireIdSubmissionsRouteRouteChildren = {
  AuthCoachQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRoute: AuthCoachQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRouteWithChildren,AuthCoachQuestionnairesQuestionnaireIdSubmissionsIndexRoute: AuthCoachQuestionnairesQuestionnaireIdSubmissionsIndexRoute
}

const AuthCoachQuestionnairesQuestionnaireIdSubmissionsRouteRouteWithChildren = AuthCoachQuestionnairesQuestionnaireIdSubmissionsRouteRoute._addFileChildren(AuthCoachQuestionnairesQuestionnaireIdSubmissionsRouteRouteChildren)



const AuthCoachQuestionnairesQuestionnaireIdRouteRouteChildren = {
  AuthCoachQuestionnairesQuestionnaireIdSubmissionsRouteRoute: AuthCoachQuestionnairesQuestionnaireIdSubmissionsRouteRouteWithChildren,AuthCoachQuestionnairesQuestionnaireIdIndexRoute: AuthCoachQuestionnairesQuestionnaireIdIndexRoute
}

const AuthCoachQuestionnairesQuestionnaireIdRouteRouteWithChildren = AuthCoachQuestionnairesQuestionnaireIdRouteRoute._addFileChildren(AuthCoachQuestionnairesQuestionnaireIdRouteRouteChildren)



const AuthCoachQuestionnairesRouteRouteChildren = {
  AuthCoachQuestionnairesQuestionnaireIdRouteRoute: AuthCoachQuestionnairesQuestionnaireIdRouteRouteWithChildren,AuthCoachQuestionnairesIndexRoute: AuthCoachQuestionnairesIndexRoute
}

const AuthCoachQuestionnairesRouteRouteWithChildren = AuthCoachQuestionnairesRouteRoute._addFileChildren(AuthCoachQuestionnairesRouteRouteChildren)




const AuthCoachLibraryExercisesRouteRouteChildren = {
  AuthCoachLibraryExercisesExerciseIdRoute: AuthCoachLibraryExercisesExerciseIdRoute,AuthCoachLibraryExercisesIndexRoute: AuthCoachLibraryExercisesIndexRoute
}

const AuthCoachLibraryExercisesRouteRouteWithChildren = AuthCoachLibraryExercisesRouteRoute._addFileChildren(AuthCoachLibraryExercisesRouteRouteChildren)




const AuthCoachLibraryProgramsProgramIdSharedSharedProgramIdRouteRouteChildren = {
  AuthCoachLibraryProgramsProgramIdSharedSharedProgramIdIndexRoute: AuthCoachLibraryProgramsProgramIdSharedSharedProgramIdIndexRoute
}

const AuthCoachLibraryProgramsProgramIdSharedSharedProgramIdRouteRouteWithChildren = AuthCoachLibraryProgramsProgramIdSharedSharedProgramIdRouteRoute._addFileChildren(AuthCoachLibraryProgramsProgramIdSharedSharedProgramIdRouteRouteChildren)



const AuthCoachLibraryProgramsProgramIdSharedRouteRouteChildren = {
  AuthCoachLibraryProgramsProgramIdSharedSharedProgramIdRouteRoute: AuthCoachLibraryProgramsProgramIdSharedSharedProgramIdRouteRouteWithChildren,AuthCoachLibraryProgramsProgramIdSharedIndexRoute: AuthCoachLibraryProgramsProgramIdSharedIndexRoute
}

const AuthCoachLibraryProgramsProgramIdSharedRouteRouteWithChildren = AuthCoachLibraryProgramsProgramIdSharedRouteRoute._addFileChildren(AuthCoachLibraryProgramsProgramIdSharedRouteRouteChildren)



const AuthCoachLibraryProgramsProgramIdRouteRouteChildren = {
  AuthCoachLibraryProgramsProgramIdSharedRouteRoute: AuthCoachLibraryProgramsProgramIdSharedRouteRouteWithChildren,AuthCoachLibraryProgramsProgramIdIndexRoute: AuthCoachLibraryProgramsProgramIdIndexRoute
}

const AuthCoachLibraryProgramsProgramIdRouteRouteWithChildren = AuthCoachLibraryProgramsProgramIdRouteRoute._addFileChildren(AuthCoachLibraryProgramsProgramIdRouteRouteChildren)



const AuthCoachLibraryProgramsRouteRouteChildren = {
  AuthCoachLibraryProgramsProgramIdRouteRoute: AuthCoachLibraryProgramsProgramIdRouteRouteWithChildren,AuthCoachLibraryProgramsIndexRoute: AuthCoachLibraryProgramsIndexRoute
}

const AuthCoachLibraryProgramsRouteRouteWithChildren = AuthCoachLibraryProgramsRouteRoute._addFileChildren(AuthCoachLibraryProgramsRouteRouteChildren)




const AuthCoachLibrarySectionsRouteRouteChildren = {
  AuthCoachLibrarySectionsIndexRoute: AuthCoachLibrarySectionsIndexRoute
}

const AuthCoachLibrarySectionsRouteRouteWithChildren = AuthCoachLibrarySectionsRouteRoute._addFileChildren(AuthCoachLibrarySectionsRouteRouteChildren)




const AuthCoachLibraryWorkoutsRouteRouteChildren = {
  AuthCoachLibraryWorkoutsWorkoutIdRoute: AuthCoachLibraryWorkoutsWorkoutIdRoute,AuthCoachLibraryWorkoutsIndexRoute: AuthCoachLibraryWorkoutsIndexRoute
}

const AuthCoachLibraryWorkoutsRouteRouteWithChildren = AuthCoachLibraryWorkoutsRouteRoute._addFileChildren(AuthCoachLibraryWorkoutsRouteRouteChildren)




const AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRouteChildren = {
  AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdIndexRoute: AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdIndexRoute
}

const AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRouteWithChildren = AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRoute._addFileChildren(AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRouteChildren)



const AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRouteChildren = {
  AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRoute: AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsSubmissionIdRouteRouteWithChildren,AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsIndexRoute: AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsIndexRoute
}

const AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRouteWithChildren = AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRoute._addFileChildren(AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRouteChildren)



const AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRouteChildren = {
  AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRoute: AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdSubmissionsRouteRouteWithChildren,AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdIndexRoute: AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdIndexRoute
}

const AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRouteWithChildren = AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRoute._addFileChildren(AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRouteChildren)



const AuthCoachOrgsSlugAthletesAthleteIdTabsRouteChildren = {
  AuthCoachOrgsSlugAthletesAthleteIdTabsProfileRoute: AuthCoachOrgsSlugAthletesAthleteIdTabsProfileRoute,AuthCoachOrgsSlugAthletesAthleteIdTabsStatisticsRoute: AuthCoachOrgsSlugAthletesAthleteIdTabsStatisticsRoute,AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRoute: AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesQuestionnaireIdRouteRouteWithChildren,AuthCoachOrgsSlugAthletesAthleteIdTabsMetricsIndexRoute: AuthCoachOrgsSlugAthletesAthleteIdTabsMetricsIndexRoute,AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesIndexRoute: AuthCoachOrgsSlugAthletesAthleteIdTabsQuestionnairesIndexRoute
}

const AuthCoachOrgsSlugAthletesAthleteIdTabsRouteWithChildren = AuthCoachOrgsSlugAthletesAthleteIdTabsRoute._addFileChildren(AuthCoachOrgsSlugAthletesAthleteIdTabsRouteChildren)



const AuthCoachOrgsSlugAthletesAthleteIdRouteRouteChildren = {
  AuthCoachOrgsSlugAthletesAthleteIdTabsRoute: AuthCoachOrgsSlugAthletesAthleteIdTabsRouteWithChildren,AuthCoachOrgsSlugAthletesAthleteIdIndexRoute: AuthCoachOrgsSlugAthletesAthleteIdIndexRoute
}

const AuthCoachOrgsSlugAthletesAthleteIdRouteRouteWithChildren = AuthCoachOrgsSlugAthletesAthleteIdRouteRoute._addFileChildren(AuthCoachOrgsSlugAthletesAthleteIdRouteRouteChildren)



const AuthCoachOrgsSlugAthletesRouteRouteChildren = {
  AuthCoachOrgsSlugAthletesAthleteIdRouteRoute: AuthCoachOrgsSlugAthletesAthleteIdRouteRouteWithChildren,AuthCoachOrgsSlugAthletesIndexRoute: AuthCoachOrgsSlugAthletesIndexRoute
}

const AuthCoachOrgsSlugAthletesRouteRouteWithChildren = AuthCoachOrgsSlugAthletesRouteRoute._addFileChildren(AuthCoachOrgsSlugAthletesRouteRouteChildren)




const AuthCoachOrgsSlugExercisesRouteRouteChildren = {
  AuthCoachOrgsSlugExercisesExerciseIdRoute: AuthCoachOrgsSlugExercisesExerciseIdRoute,AuthCoachOrgsSlugExercisesIndexRoute: AuthCoachOrgsSlugExercisesIndexRoute
}

const AuthCoachOrgsSlugExercisesRouteRouteWithChildren = AuthCoachOrgsSlugExercisesRouteRoute._addFileChildren(AuthCoachOrgsSlugExercisesRouteRouteChildren)




const AuthCoachOrgsSlugProgramsRouteRouteChildren = {
  AuthCoachOrgsSlugProgramsIndexRoute: AuthCoachOrgsSlugProgramsIndexRoute
}

const AuthCoachOrgsSlugProgramsRouteRouteWithChildren = AuthCoachOrgsSlugProgramsRouteRoute._addFileChildren(AuthCoachOrgsSlugProgramsRouteRouteChildren)




const AuthCoachOrgsSlugSettingsIntegrationsAppleHealthRouteRouteChildren = {
  AuthCoachOrgsSlugSettingsIntegrationsAppleHealthIndexRoute: AuthCoachOrgsSlugSettingsIntegrationsAppleHealthIndexRoute
}

const AuthCoachOrgsSlugSettingsIntegrationsAppleHealthRouteRouteWithChildren = AuthCoachOrgsSlugSettingsIntegrationsAppleHealthRouteRoute._addFileChildren(AuthCoachOrgsSlugSettingsIntegrationsAppleHealthRouteRouteChildren)




const AuthCoachOrgsSlugSettingsIntegrationsStravaRouteRouteChildren = {
  AuthCoachOrgsSlugSettingsIntegrationsStravaActivitiesRoute: AuthCoachOrgsSlugSettingsIntegrationsStravaActivitiesRoute,AuthCoachOrgsSlugSettingsIntegrationsStravaIndexRoute: AuthCoachOrgsSlugSettingsIntegrationsStravaIndexRoute
}

const AuthCoachOrgsSlugSettingsIntegrationsStravaRouteRouteWithChildren = AuthCoachOrgsSlugSettingsIntegrationsStravaRouteRoute._addFileChildren(AuthCoachOrgsSlugSettingsIntegrationsStravaRouteRouteChildren)



const AuthCoachOrgsSlugSettingsIntegrationsRouteRouteChildren = {
  AuthCoachOrgsSlugSettingsIntegrationsAppleHealthRouteRoute: AuthCoachOrgsSlugSettingsIntegrationsAppleHealthRouteRouteWithChildren,AuthCoachOrgsSlugSettingsIntegrationsStravaRouteRoute: AuthCoachOrgsSlugSettingsIntegrationsStravaRouteRouteWithChildren,AuthCoachOrgsSlugSettingsIntegrationsIndexRoute: AuthCoachOrgsSlugSettingsIntegrationsIndexRoute
}

const AuthCoachOrgsSlugSettingsIntegrationsRouteRouteWithChildren = AuthCoachOrgsSlugSettingsIntegrationsRouteRoute._addFileChildren(AuthCoachOrgsSlugSettingsIntegrationsRouteRouteChildren)



const AuthCoachOrgsSlugSettingsRouteRouteChildren = {
  AuthCoachOrgsSlugSettingsIntegrationsRouteRoute: AuthCoachOrgsSlugSettingsIntegrationsRouteRouteWithChildren,AuthCoachOrgsSlugSettingsBillingRoute: AuthCoachOrgsSlugSettingsBillingRoute,AuthCoachOrgsSlugSettingsMcpRoute: AuthCoachOrgsSlugSettingsMcpRoute,AuthCoachOrgsSlugSettingsMembersRoute: AuthCoachOrgsSlugSettingsMembersRoute,AuthCoachOrgsSlugSettingsPreferencesRoute: AuthCoachOrgsSlugSettingsPreferencesRoute,AuthCoachOrgsSlugSettingsProfileRoute: AuthCoachOrgsSlugSettingsProfileRoute,AuthCoachOrgsSlugSettingsIndexRoute: AuthCoachOrgsSlugSettingsIndexRoute
}

const AuthCoachOrgsSlugSettingsRouteRouteWithChildren = AuthCoachOrgsSlugSettingsRouteRoute._addFileChildren(AuthCoachOrgsSlugSettingsRouteRouteChildren)




const AuthCoachOrgsSlugWorkoutsRouteRouteChildren = {
  AuthCoachOrgsSlugWorkoutsIndexRoute: AuthCoachOrgsSlugWorkoutsIndexRoute
}

const AuthCoachOrgsSlugWorkoutsRouteRouteWithChildren = AuthCoachOrgsSlugWorkoutsRouteRoute._addFileChildren(AuthCoachOrgsSlugWorkoutsRouteRouteChildren)



const AuthCoachOrgsSlugRouteRouteChildren = {
  AuthCoachOrgsSlugAthletesRouteRoute: AuthCoachOrgsSlugAthletesRouteRouteWithChildren,AuthCoachOrgsSlugExercisesRouteRoute: AuthCoachOrgsSlugExercisesRouteRouteWithChildren,AuthCoachOrgsSlugProgramsRouteRoute: AuthCoachOrgsSlugProgramsRouteRouteWithChildren,AuthCoachOrgsSlugSettingsRouteRoute: AuthCoachOrgsSlugSettingsRouteRouteWithChildren,AuthCoachOrgsSlugWorkoutsRouteRoute: AuthCoachOrgsSlugWorkoutsRouteRouteWithChildren,AuthCoachOrgsSlugIndexRoute: AuthCoachOrgsSlugIndexRoute,AuthCoachOrgsSlugLabelsIndexRoute: AuthCoachOrgsSlugLabelsIndexRoute
}

const AuthCoachOrgsSlugRouteRouteWithChildren = AuthCoachOrgsSlugRouteRoute._addFileChildren(AuthCoachOrgsSlugRouteRouteChildren)




const AuthCoachWorkflowsWorkflowIdRouteRouteChildren = {
  AuthCoachWorkflowsWorkflowIdAthletesRoute: AuthCoachWorkflowsWorkflowIdAthletesRoute,AuthCoachWorkflowsWorkflowIdScheduleRoute: AuthCoachWorkflowsWorkflowIdScheduleRoute,AuthCoachWorkflowsWorkflowIdSettingsRoute: AuthCoachWorkflowsWorkflowIdSettingsRoute,AuthCoachWorkflowsWorkflowIdIndexRoute: AuthCoachWorkflowsWorkflowIdIndexRoute
}

const AuthCoachWorkflowsWorkflowIdRouteRouteWithChildren = AuthCoachWorkflowsWorkflowIdRouteRoute._addFileChildren(AuthCoachWorkflowsWorkflowIdRouteRouteChildren)



const AuthCoachRouteRouteChildren = {
  AuthCoachAiRouteRoute: AuthCoachAiRouteRouteWithChildren,AuthCoachAthletesRouteRoute: AuthCoachAthletesRouteRouteWithChildren,AuthCoachAutomationsRouteRoute: AuthCoachAutomationsRouteRouteWithChildren,AuthCoachContentHubRouteRoute: AuthCoachContentHubRouteRouteWithChildren,AuthCoachProductsRouteRoute: AuthCoachProductsRouteRouteWithChildren,AuthCoachProfileRouteRoute: AuthCoachProfileRouteRouteWithChildren,AuthCoachQuestionnairesRouteRoute: AuthCoachQuestionnairesRouteRouteWithChildren,AuthCoachCreateOrgRoute: AuthCoachCreateOrgRoute,AuthCoachLibraryExercisesRouteRoute: AuthCoachLibraryExercisesRouteRouteWithChildren,AuthCoachLibraryProgramsRouteRoute: AuthCoachLibraryProgramsRouteRouteWithChildren,AuthCoachLibrarySectionsRouteRoute: AuthCoachLibrarySectionsRouteRouteWithChildren,AuthCoachLibraryWorkoutsRouteRoute: AuthCoachLibraryWorkoutsRouteRouteWithChildren,AuthCoachOrgsSlugRouteRoute: AuthCoachOrgsSlugRouteRouteWithChildren,AuthCoachWorkflowsWorkflowIdRouteRoute: AuthCoachWorkflowsWorkflowIdRouteRouteWithChildren,AuthCoachBundlesIndexRoute: AuthCoachBundlesIndexRoute,AuthCoachLabelsIndexRoute: AuthCoachLabelsIndexRoute,AuthCoachLibraryIndexRoute: AuthCoachLibraryIndexRoute,AuthCoachWorkflowsIndexRoute: AuthCoachWorkflowsIndexRoute,AuthCoachLibraryResourcesIndexRoute: AuthCoachLibraryResourcesIndexRoute,AuthCoachLibraryTasksIndexRoute: AuthCoachLibraryTasksIndexRoute
}

const AuthCoachRouteRouteWithChildren = AuthCoachRouteRoute._addFileChildren(AuthCoachRouteRouteChildren)




const AuthChatRouteRouteChildren = {
  AuthChatChatIdRoute: AuthChatChatIdRoute,AuthChatIndexRoute: AuthChatIndexRoute
}

const AuthChatRouteRouteWithChildren = AuthChatRouteRoute._addFileChildren(AuthChatRouteRouteChildren)




const AuthSettingsIntegrationsAppleHealthRouteRouteChildren = {
  AuthSettingsIntegrationsAppleHealthIndexRoute: AuthSettingsIntegrationsAppleHealthIndexRoute
}

const AuthSettingsIntegrationsAppleHealthRouteRouteWithChildren = AuthSettingsIntegrationsAppleHealthRouteRoute._addFileChildren(AuthSettingsIntegrationsAppleHealthRouteRouteChildren)




const AuthSettingsIntegrationsStravaRouteRouteChildren = {
  AuthSettingsIntegrationsStravaActivitiesRoute: AuthSettingsIntegrationsStravaActivitiesRoute,AuthSettingsIntegrationsStravaIndexRoute: AuthSettingsIntegrationsStravaIndexRoute
}

const AuthSettingsIntegrationsStravaRouteRouteWithChildren = AuthSettingsIntegrationsStravaRouteRoute._addFileChildren(AuthSettingsIntegrationsStravaRouteRouteChildren)



const AuthSettingsIntegrationsRouteRouteChildren = {
  AuthSettingsIntegrationsAppleHealthRouteRoute: AuthSettingsIntegrationsAppleHealthRouteRouteWithChildren,AuthSettingsIntegrationsStravaRouteRoute: AuthSettingsIntegrationsStravaRouteRouteWithChildren,AuthSettingsIntegrationsIndexRoute: AuthSettingsIntegrationsIndexRoute
}

const AuthSettingsIntegrationsRouteRouteWithChildren = AuthSettingsIntegrationsRouteRoute._addFileChildren(AuthSettingsIntegrationsRouteRouteChildren)



const AuthSettingsRouteRouteChildren = {
  AuthSettingsIntegrationsRouteRoute: AuthSettingsIntegrationsRouteRouteWithChildren,AuthSettingsBillingRoute: AuthSettingsBillingRoute,AuthSettingsMcpRoute: AuthSettingsMcpRoute,AuthSettingsPreferencesRoute: AuthSettingsPreferencesRoute,AuthSettingsIndexRoute: AuthSettingsIndexRoute
}

const AuthSettingsRouteRouteWithChildren = AuthSettingsRouteRoute._addFileChildren(AuthSettingsRouteRouteChildren)



const AuthRouteRouteChildren = {
  AuthAdminRouteRoute: AuthAdminRouteRouteWithChildren,AuthAthleteRouteRoute: AuthAthleteRouteRouteWithChildren,AuthCoachRouteRoute: AuthCoachRouteRouteWithChildren,AuthChatRouteRoute: AuthChatRouteRouteWithChildren,AuthSettingsRouteRoute: AuthSettingsRouteRouteWithChildren,AuthInvitationsIndexRoute: AuthInvitationsIndexRoute
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(AuthRouteRouteChildren)




const HybridWorkflowWorkflowIdRouteRouteChildren = {
  HybridWorkflowWorkflowIdJoinRoute: HybridWorkflowWorkflowIdJoinRoute
}

const HybridWorkflowWorkflowIdRouteRouteWithChildren = HybridWorkflowWorkflowIdRouteRoute._addFileChildren(HybridWorkflowWorkflowIdRouteRouteChildren)



const HybridRouteRouteChildren = {
  HybridConnectRoute: HybridConnectRoute,HybridWorkflowWorkflowIdRouteRoute: HybridWorkflowWorkflowIdRouteRouteWithChildren
}

const HybridRouteRouteWithChildren = HybridRouteRoute._addFileChildren(HybridRouteRouteChildren)




const PublicResetPasswordRouteRouteChildren = {
  PublicResetPasswordResetIdRoute: PublicResetPasswordResetIdRoute,PublicResetPasswordIndexRoute: PublicResetPasswordIndexRoute
}

const PublicResetPasswordRouteRouteWithChildren = PublicResetPasswordRouteRoute._addFileChildren(PublicResetPasswordRouteRouteChildren)




const PublicInvitationsInvitationIdRouteRouteChildren = {
  PublicInvitationsInvitationIdIndexRoute: PublicInvitationsInvitationIdIndexRoute
}

const PublicInvitationsInvitationIdRouteRouteWithChildren = PublicInvitationsInvitationIdRouteRoute._addFileChildren(PublicInvitationsInvitationIdRouteRouteChildren)



const PublicRouteRouteChildren = {
  PublicResetPasswordRouteRoute: PublicResetPasswordRouteRouteWithChildren,PublicContactRoute: PublicContactRoute,PublicDeleteAccountRoute: PublicDeleteAccountRoute,PublicPrivacyRoute: PublicPrivacyRoute,PublicSignInRoute: PublicSignInRoute,PublicSignUpRoute: PublicSignUpRoute,PublicInvitationsInvitationIdRouteRoute: PublicInvitationsInvitationIdRouteRouteWithChildren,PublicSharedSharedIdRoute: PublicSharedSharedIdRoute
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(PublicRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthRouteRoute: AuthRouteRouteWithChildren,HybridRouteRoute: HybridRouteRouteWithChildren,PublicRouteRoute: PublicRouteRouteWithChildren,PricingRoute: PricingRoute,CSlugRoute: CSlugRoute,OrganizationInvitationsInvitationIdRoute: OrganizationInvitationsInvitationIdRoute,VerifyEmailVerificationIdRoute: VerifyEmailVerificationIdRoute,CSlugPProductSlugRoute: CSlugPProductSlugRoute,CSlugPProductSlugSuccessRoute: CSlugPProductSlugSuccessRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)